var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTutory2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-97"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-97",
    cx: 249,
    cy: 356.02,
    rx: 237.21,
    ry: 136.95,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-97",
    d: "M62.7,278C50,285.45,50,297.52,62.7,305s33.41,7.44,46.16,0,12.74-19.51,0-26.95S75.45,270.57,62.7,278Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-97",
    d: "M401.07,393.48l57.63-33.27a3.33,3.33,0,0,1,3,0l7.67,4.42a.93.93,0,0,1,0,1.76l-57.78,33.36a3.31,3.31,0,0,1-3,0l-7.54-4.47A.94.94,0,0,1,401.07,393.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-97",
    d: "M184.18,376.12l-77.51-44.87c-5-2.91-5-7.64,0-10.56l48.4-28.28c5.05-2.92,13.24-2.92,18.28,0l77.51,44.87c5,2.91,5,7.64,0,10.56l-48.4,28.28C197.41,379,189.23,379,184.18,376.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-97",
    points: "239.65 487.64 112.68 414.33 320.65 294.21 447.62 367.51 239.65 487.64",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-97",
    d: "M70.38,379.72c-8.11,4.67-8.11,12.26,0,16.93s21.23,4.68,29.33,0,8.1-12.26,0-16.93S78.48,375,70.38,379.72Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8,290.25c-9.95-10.27-15.79-52-6.09-60.19h49.37c9.7,8.14,3.86,49.9-6.08,60.18l-.27.28-.34.34q-.42.4-.9.81l-.24.18c-.24.2-.49.39-.75.58a14,14,0,0,1-1.29.83C94,298,80.76,298,72.58,293.26h0a14.31,14.31,0,0,1-1.3-.84c-.24-.17-.47-.35-.7-.53l-.29-.24a11,11,0,0,1-.87-.78l-.39-.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.79,226.78c11.27,6.58,11.27,17.24,0,23.82s-29.53,6.58-40.79,0-11.27-17.24,0-23.82S96.53,220.21,107.79,226.78Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.37,230c8.28,4.83,8.28,12.66,0,17.49s-21.68,4.83-29.95,0-8.28-12.66,0-17.49S94.1,225.12,102.37,230Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.42,238.25c8.27-4.83,21.68-4.83,30,0a13.82,13.82,0,0,1,5,4.59,13.75,13.75,0,0,1-5,4.6c-8.27,4.83-21.68,4.83-29.95,0a13.75,13.75,0,0,1-5-4.6A13.82,13.82,0,0,1,72.42,238.25Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.54,153,90.8,167.87l18.13-8.36a50.12,50.12,0,0,1-3.15,17.17s-8.93,5.32-14.11,10l13.89-5.49s1,9.16-2.86,23.13c-1,3.66-5.11,10.64-7.7,15.86a59.07,59.07,0,0,1-4,7c-.08.15-.18.28-.28.43q-4.77-2.73-9.9-5.29c-2.24-4.7-5.15-16.3-6.2-25.8-4-36.38,23.5-57.22,45.61-64.21C120.19,132.28,112.6,141.81,109.54,153Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.87,154.53c-3.83,3.85-6.07,8.91-7.78,14a73.66,73.66,0,0,0-3.33,15.74,68.08,68.08,0,0,0,4,31.58v0a.52.52,0,0,1-.3.68.53.53,0,0,1-.68-.3h0a68.88,68.88,0,0,1-3.51-32,74,74,0,0,1,3.6-15.76C87.64,163.37,90,158.32,93.87,154.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.41,172.08l0,0c.47.56,8.16,9.71,19.58,27.52l19,3.06-14,2.45,7.53,11.93,18.72,3.87-14.62,2.38s4.06,14.26,14.52,20.21c5.77,3.28,8.6,3.78,10.33,2.13,1.21-1.15,1.5-8,2.51-14.1s1.09-16-4.67-28a37.69,37.69,0,0,0-6-8.81C67.5,179.33,41.34,171.89,28.41,172.08Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.31,178.31c9.83,4.31,19.14,10.23,26.45,18.27A51.91,51.91,0,0,1,83.82,210,49.37,49.37,0,0,1,88,225.65a.06.06,0,0,1,0,.06.07.07,0,0,1-.06,0,63.43,63.43,0,0,0-5-15.2,58.65,58.65,0,0,0-8.74-13.33C67.06,189.09,58,183,48.26,178.4a.06.06,0,0,1,0-.07A0,0,0,0,1,48.31,178.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.72,179.93h0a41.33,41.33,0,0,0-4.79.22,76.56,76.56,0,0,0-18.3,4.46c-2.19.81-4.38,1.74-6.54,2.77-1.08.51-2.15,1.06-3.2,1.62a53.05,53.05,0,0,0-14,10.61A33.47,33.47,0,0,0,90,206.39c-.17.32-.36.63-.52,1h0c-.41.84-.77,1.66-1.12,2.47-4,9.14-4.39,15.49-4.13,22.52.2,5.46,2,11.7,3.12,12.72a2.35,2.35,0,0,0,.47.36c1.56,1,4,.41,8.66-2.18,9.27-5.18,12.9-18.31,12.9-18.31l-12.88-2.19,16.54-3.3L119.8,209l-12.36-2.25,16.8-2.59c10.19-15.64,17-23.67,17.45-24.16l0,0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.93,180.15a76.56,76.56,0,0,0-18.3,4.46c-2.19.81-4.38,1.74-6.54,2.77-1.08.51-2.15,1.06-3.2,1.62a53.05,53.05,0,0,0-14,10.61A33.47,33.47,0,0,0,90,206.39c-.17.32-.36.63-.52,1h0c-.41.84-.77,1.66-1.12,2.47-4,9.14-4.39,15.49-4.13,22.52.2,5.46,2,11.7,3.12,12.72a2.35,2.35,0,0,0,.47.36,2.9,2.9,0,0,0,1,.37c-1.14-8.46,3-29.92,9.32-38.74,6.56-9.18,22.11-22.5,43.49-27.09v0A40.51,40.51,0,0,0,136.93,180.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.83,245.79A72.53,72.53,0,0,1,90,227.08a60.6,60.6,0,0,1,6.21-17.75c3.17-5.52,7.72-10,12.57-14a70.22,70.22,0,0,1,16.12-9.66.05.05,0,0,1,.07,0,0,0,0,0,1,0,.06,92.4,92.4,0,0,0-15.5,10.39,68,68,0,0,0-6.81,6.33A41.73,41.73,0,0,0,97,209.76a59.6,59.6,0,0,0-6.42,17.43,72.57,72.57,0,0,0-1.63,18.6,0,0,0,0,1-.05.05S88.83,245.82,88.83,245.79Z",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-97"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "479.91 224.66 477.15 226.31 355.69 156.19 358.45 154.54 479.91 224.66",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.45 154.54 477.15 223.06 477.15 116.51 358.45 48.01 358.45 154.54",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.97 79 416.97 191.64 411.75 188.63 411.75 75.98 416.97 79",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.58 77.48 416.97 79 416.97 191.64 419.58 190.13 419.58 77.48",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.47,159.2l131.9,76.15V113.5L350.47,37.35Zm5.22-112.81,121.46,70.12v109.8L355.69,156.19Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.69 156.19 358.45 154.54 358.45 48.01 355.69 46.39 355.69 156.19",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.47 37.34 353.28 35.74 485.18 111.89 482.37 113.5 350.47 37.34",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "485.18 111.89 482.37 113.5 482.37 235.35 485.18 233.75 485.18 111.89",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.97 82.01 411.76 79 411.76 82.01 416.97 85.02 416.97 82.01",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.97 85.02 419.58 83.51 416.97 82.01 416.97 85.02",
    style: {
      opacity: 0.15
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Elements--inject-97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gear--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.19,170.64a14.83,14.83,0,0,1-2.51-.21.92.92,0,0,1-.77-.92v-2a12.33,12.33,0,0,1-3-1.24l-1.4,1.41a.93.93,0,0,1-1.2.1,15.38,15.38,0,0,1-3.56-3.55.94.94,0,0,1,.1-1.2l1.42-1.41a12.42,12.42,0,0,1-1.24-3H52a.92.92,0,0,1-.92-.77,15.21,15.21,0,0,1-.21-2.52,15,15,0,0,1,.21-2.51.92.92,0,0,1,.92-.77h2a12.67,12.67,0,0,1,1.24-3l-1.41-1.4a.94.94,0,0,1-.11-1.2,15.38,15.38,0,0,1,3.56-3.55.93.93,0,0,1,1.2.1l1.4,1.4a12.63,12.63,0,0,1,3-1.23v-2a.92.92,0,0,1,.77-.92,15.17,15.17,0,0,1,5,0,.93.93,0,0,1,.77.92v2a12.56,12.56,0,0,1,3,1.23l1.41-1.4a.91.91,0,0,1,1.19-.1,15.19,15.19,0,0,1,3.56,3.55.94.94,0,0,1-.1,1.2l-1.41,1.4a12.67,12.67,0,0,1,1.24,3h2a.93.93,0,0,1,.92.77,16,16,0,0,1,.2,2.51,16.56,16.56,0,0,1-.2,2.52.93.93,0,0,1-.92.77h-2a12.42,12.42,0,0,1-1.24,3l1.4,1.41a.92.92,0,0,1,.11,1.19,15,15,0,0,1-3.56,3.56.91.91,0,0,1-1.19-.1l-1.41-1.41a12.66,12.66,0,0,1-3,1.24v2a.93.93,0,0,1-.77.92A15,15,0,0,1,66.19,170.64Zm-2.27-1.2a14.4,14.4,0,0,0,4.54,0v-2.72l.39-.09a11.52,11.52,0,0,0,3.43-1.42l.35-.21,1.92,1.92a14,14,0,0,0,3.2-3.22l-1.92-1.92.22-.34A11.79,11.79,0,0,0,77.47,158l.09-.39h2.71a14.79,14.79,0,0,0,.18-2.28,15.45,15.45,0,0,0-.17-2.27H77.56l-.09-.39A11.72,11.72,0,0,0,76,149.26l-.21-.34L77.76,147a14.21,14.21,0,0,0-3.22-3.21l-1.91,1.92-.35-.21a11.37,11.37,0,0,0-3.42-1.42l-.4-.09v-2.72a14.4,14.4,0,0,0-4.54,0V144l-.39.09a11.43,11.43,0,0,0-3.43,1.42l-.34.21-1.92-1.92A14,14,0,0,0,54.63,147l1.92,1.92-.21.34a11.43,11.43,0,0,0-1.42,3.43l-.1.39H52.11a14.47,14.47,0,0,0,0,4.55h2.71l.1.39a11.27,11.27,0,0,0,1.42,3.42l.21.34-1.92,1.93a14,14,0,0,0,3.21,3.21L59.76,165l.34.21a11.63,11.63,0,0,0,3.43,1.42l.39.09Zm4.62-28.16Zm-4.69,0Zm2.35,21.5a7.39,7.39,0,0,1-5.26-2.17,7.54,7.54,0,0,1-1.67-8,7.08,7.08,0,0,1,4.14-4.14,7.48,7.48,0,0,1,9.71,9.7A7,7,0,0,1,69,162.27,7.93,7.93,0,0,1,66.2,162.78Zm0-13.83a7.1,7.1,0,0,0-2.42.43,6.06,6.06,0,0,0-3.54,3.54,6.47,6.47,0,0,0,8.4,8.4h0a6,6,0,0,0,3.54-3.54,6.53,6.53,0,0,0-1.43-7A6.37,6.37,0,0,0,66.18,149Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.92,149.61a9.82,9.82,0,0,1-1.72-.14.62.62,0,0,1-.52-.62v-1.37a8.35,8.35,0,0,1-2.05-.84l-1,1a.64.64,0,0,1-.82.07,10.38,10.38,0,0,1-2.43-2.43.64.64,0,0,1,.07-.82l1-1a8.44,8.44,0,0,1-.84-2H82.25a.64.64,0,0,1-.63-.53,10,10,0,0,1-.15-1.72,9.82,9.82,0,0,1,.15-1.72.63.63,0,0,1,.63-.53h1.36a8.44,8.44,0,0,1,.84-2l-1-1a.64.64,0,0,1-.07-.82,10.2,10.2,0,0,1,2.43-2.43.64.64,0,0,1,.82.07l1,1a8.54,8.54,0,0,1,2.05-.85v-1.36a.63.63,0,0,1,.52-.63,11,11,0,0,1,3.44,0,.63.63,0,0,1,.53.63v1.36a8.47,8.47,0,0,1,2,.85l1-1a.64.64,0,0,1,.82-.07,10.2,10.2,0,0,1,2.43,2.43.64.64,0,0,1-.07.82l-1,1a8.89,8.89,0,0,1,.85,2h1.36a.63.63,0,0,1,.63.53,10.89,10.89,0,0,1,.14,1.72,10.17,10.17,0,0,1-.15,1.72.63.63,0,0,1-.62.53h-1.36a8.89,8.89,0,0,1-.85,2l1,1a.64.64,0,0,1,.07.82A10.38,10.38,0,0,1,98,147.67a.64.64,0,0,1-.82-.07l-1-1a8.12,8.12,0,0,1-2,.84v1.37a.62.62,0,0,1-.53.62A9.74,9.74,0,0,1,91.92,149.61Zm-1.55-.81a10.07,10.07,0,0,0,3.1,0v-1.86l.27-.07a7.65,7.65,0,0,0,2.34-1l.24-.15,1.31,1.31a9.68,9.68,0,0,0,2.19-2.19l-1.31-1.32.15-.23a8,8,0,0,0,1-2.34l.06-.27h1.86a10.21,10.21,0,0,0,.12-1.55,9.83,9.83,0,0,0-.12-1.55H99.69l-.06-.27a8.05,8.05,0,0,0-1-2.35l-.15-.23,1.32-1.31a9.77,9.77,0,0,0-2.2-2.2l-1.31,1.32-.24-.15a7.88,7.88,0,0,0-2.34-1l-.27-.06v-1.86a10.07,10.07,0,0,0-3.1,0v1.86l-.27.06a8.11,8.11,0,0,0-2.34,1l-.24.15-1.31-1.32a9.73,9.73,0,0,0-2.19,2.2l1.31,1.31-.14.23a7.79,7.79,0,0,0-1,2.35l-.07.27H82.3a9.31,9.31,0,0,0,0,3.1h1.85l.07.27a7.73,7.73,0,0,0,1,2.34l.14.23L84,144.88a9.68,9.68,0,0,0,2.19,2.19l1.31-1.31.24.15a7.86,7.86,0,0,0,2.34,1l.27.07Zm3.16-19.25Zm-3.21,0Zm1.61,14.69a5.06,5.06,0,0,1-3.6-1.48,5.17,5.17,0,0,1-1.14-5.49A4.84,4.84,0,0,1,90,134.43a5.11,5.11,0,0,1,6.63,6.64,4.82,4.82,0,0,1-2.83,2.83A5.43,5.43,0,0,1,91.93,144.24Zm0-9.45a4.84,4.84,0,0,0-1.65.3,4.1,4.1,0,0,0-2.42,2.42,4.41,4.41,0,0,0,5.74,5.73h0A4.11,4.11,0,0,0,96,140.83a4.46,4.46,0,0,0-1-4.76A4.36,4.36,0,0,0,91.91,134.79Z",
    style: {
      fill: "#BA68C8"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.75,182.61a15.6,15.6,0,0,1,2.12-1.37.93.93,0,0,1,1.17.26l1.21,1.58a12.7,12.7,0,0,1,3.13-.83l.26-2a.92.92,0,0,1,.89-.81,15.36,15.36,0,0,1,5,.65.93.93,0,0,1,.64,1l-.26,2a12.61,12.61,0,0,1,2.8,1.62l1.58-1.21a.92.92,0,0,1,1.2,0,15.94,15.94,0,0,1,1.7,1.88,15.26,15.26,0,0,1,1.36,2.12.93.93,0,0,1-.26,1.17L469.7,190a12.93,12.93,0,0,1,.84,3.13l2,.26a.93.93,0,0,1,.81.89,15.24,15.24,0,0,1-.66,5,.93.93,0,0,1-1,.65l-2-.26a12.23,12.23,0,0,1-1.62,2.8l1.21,1.58a.92.92,0,0,1-.05,1.2,15.65,15.65,0,0,1-4,3.06A.94.94,0,0,1,464,208l-1.21-1.58a12.4,12.4,0,0,1-3.12.83l-.27,2a.91.91,0,0,1-.88.81,15.33,15.33,0,0,1-5-.65.94.94,0,0,1-.65-1l.27-2a12.67,12.67,0,0,1-2.81-1.62L448.81,206a.94.94,0,0,1-1.2-.05,15.35,15.35,0,0,1-3.06-4,.91.91,0,0,1,.26-1.17l1.57-1.21a12.58,12.58,0,0,1-.83-3.13l-2-.26a.93.93,0,0,1-.81-.89,15,15,0,0,1,.66-5,.92.92,0,0,1,1-.65l2,.26a12.71,12.71,0,0,1,1.63-2.8l-1.22-1.58a.94.94,0,0,1,.06-1.2A15.17,15.17,0,0,1,448.75,182.61Zm2.53-.43a14.44,14.44,0,0,0-3.6,2.76l1.65,2.16-.25.31a11.12,11.12,0,0,0-1.86,3.21l-.15.38-2.69-.36a14,14,0,0,0-.59,4.5l2.69.36,0,.4a11.43,11.43,0,0,0,1,3.58l.17.37-2.16,1.65a14.91,14.91,0,0,0,1.24,1.91,15.47,15.47,0,0,0,1.52,1.7l2.16-1.65.31.25a11.61,11.61,0,0,0,3.22,1.86l.37.14-.36,2.7a14.62,14.62,0,0,0,4.5.59l.36-2.69.4,0a11.58,11.58,0,0,0,3.58-1l.37-.17,1.66,2.16a14.44,14.44,0,0,0,3.6-2.76l-1.66-2.16.26-.31a11.32,11.32,0,0,0,1.86-3.21l.14-.38,2.7.36a14.55,14.55,0,0,0,.6-4.5l-2.7-.35,0-.4a11.64,11.64,0,0,0-1-3.59l-.16-.37L470.6,188a13.22,13.22,0,0,0-1.23-1.91,13.74,13.74,0,0,0-1.53-1.7L465.69,186l-.32-.25a11.29,11.29,0,0,0-3.21-1.85l-.37-.15.35-2.7a14.54,14.54,0,0,0-4.5-.59l-.35,2.69-.41,0a11.6,11.6,0,0,0-3.58,1l-.37.17Zm13.46,25.16Zm3.72-2.85Zm-14.94-15.63a7.35,7.35,0,0,1,5.5-1.48,7.54,7.54,0,0,1,6.21,5.36,7.08,7.08,0,0,1-.77,5.81,7.48,7.48,0,0,1-13.6-1.8,7.07,7.07,0,0,1,.77-5.81A7.72,7.72,0,0,1,453.52,188.86Zm8.43,11A6.87,6.87,0,0,0,463.6,198a6,6,0,0,0,.66-5,6.47,6.47,0,0,0-11.77-1.56h0a6,6,0,0,0-.66,5,6.55,6.55,0,0,0,5.37,4.66A6.39,6.39,0,0,0,462,199.82Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.11,214.94a10.18,10.18,0,0,1,1.45-.93.63.63,0,0,1,.8.18l.83,1.08a8,8,0,0,1,2.13-.57l.18-1.35a.63.63,0,0,1,.61-.55,10.39,10.39,0,0,1,3.41.44.66.66,0,0,1,.44.7l-.18,1.35a8.25,8.25,0,0,1,1.91,1.1l1.08-.82a.63.63,0,0,1,.82,0,12.86,12.86,0,0,1,1.17,1.28,10.61,10.61,0,0,1,.93,1.46.64.64,0,0,1-.18.8l-1.08.82a8.79,8.79,0,0,1,.57,2.14l1.35.18a.64.64,0,0,1,.55.61,10.3,10.3,0,0,1-.45,3.4.62.62,0,0,1-.69.44l-1.35-.17a8.66,8.66,0,0,1-1.11,1.91l.83,1.08a.64.64,0,0,1,0,.82,10.55,10.55,0,0,1-2.73,2.09.63.63,0,0,1-.8-.18l-.83-1.08a8.31,8.31,0,0,1-2.13.58l-.18,1.34a.65.65,0,0,1-.61.56,10.67,10.67,0,0,1-3.41-.45.65.65,0,0,1-.44-.7l.18-1.35a8.25,8.25,0,0,1-1.91-1.1l-1.08.82a.63.63,0,0,1-.82,0,10.08,10.08,0,0,1-1.16-1.28,10.85,10.85,0,0,1-.93-1.45.63.63,0,0,1,.17-.81l1.08-.82a8.79,8.79,0,0,1-.57-2.14l-1.34-.18a.63.63,0,0,1-.56-.6,10.33,10.33,0,0,1,.45-3.41.62.62,0,0,1,.69-.44l1.35.17a8.5,8.5,0,0,1,1.11-1.91l-.83-1.08a.64.64,0,0,1,0-.82A10.22,10.22,0,0,1,441.11,214.94Zm1.73-.29a10.09,10.09,0,0,0-2.47,1.88l1.14,1.48-.18.21a8.08,8.08,0,0,0-1.27,2.2l-.1.26-1.84-.25a9.7,9.7,0,0,0-.4,3.08l1.84.24,0,.28a8,8,0,0,0,.66,2.45l.11.25-1.47,1.13a9.89,9.89,0,0,0,1.88,2.46l1.48-1.13.21.18a8.31,8.31,0,0,0,2.2,1.27l.25.09-.24,1.85a9.67,9.67,0,0,0,3.07.4l.25-1.84.27,0a7.66,7.66,0,0,0,2.45-.65l.25-.12,1.13,1.48a10.09,10.09,0,0,0,2.47-1.88l-1.14-1.48.18-.22a7.61,7.61,0,0,0,1.27-2.19l.1-.26,1.84.25a9.71,9.71,0,0,0,.41-3.08l-1.84-.24,0-.27a8.08,8.08,0,0,0-.66-2.46l-.11-.25,1.48-1.13a10,10,0,0,0-.85-1.3,8.8,8.8,0,0,0-1-1.16l-1.48,1.13-.21-.18a8.1,8.1,0,0,0-2.19-1.26l-.26-.1.24-1.85a9.67,9.67,0,0,0-3.07-.4l-.25,1.84-.27,0a7.8,7.8,0,0,0-2.45.65l-.25.12Zm9.2,17.2Zm2.54-1.95Zm-10.21-10.69a5.09,5.09,0,0,1,3.76-1,5.15,5.15,0,0,1,4.24,3.67,4.83,4.83,0,0,1-.52,4,5.12,5.12,0,0,1-9.3-1.23,4.82,4.82,0,0,1,.53-4A5.22,5.22,0,0,1,444.37,219.21Zm5.76,7.5a4.8,4.8,0,0,0,1.13-1.24,4.15,4.15,0,0,0,.45-3.4,4.42,4.42,0,0,0-8-1.06h0a4.13,4.13,0,0,0-.45,3.39,4.48,4.48,0,0,0,3.68,3.18A4.36,4.36,0,0,0,450.13,226.71Z",
    style: {
      fill: "#BA68C8"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.49,197.62c-.36,5.1-.23,10-.3,15S92,222.49,92,227.4c-.13,10-.15,19.88.22,29.66,0,.41,1.1,0,1.08-.42-.38-9.83-.36-19.81-.26-29.82.1-9.78.73-19.83,0-29.28,0-.14-.48-.12-.49.08Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.54,254.07c12.66.09,25.49-.07,38.13.06s25,.35,37.38.64c.5,0,1.18-.72.61-.73-12.3-.28-24.63-.52-37-.63-12.76-.11-25.54-.28-38.66.17-.41,0-.87.49-.41.49Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.53,198.93a7.86,7.86,0,0,0,.79,1.59c.3.51.62,1,1,1.49.07.09.26.1.47,0s.36-.25.28-.34c-.35-.48-.69-1-1-1.48s-.56-1-.87-1.5c-.09-.13-.7,0-.63.22Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.52,198.35c-.58,1-1.06,1.93-1.54,2.89l-.72,1.44-.37.75a5.76,5.76,0,0,0-.34.72c-.07.25.51.26.71,0a12.19,12.19,0,0,0,.68-1.35l.66-1.36c.49-1,1-2,1.35-3,.06-.15-.31-.22-.43,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.63,257c-.2.28,0,.39.15.52s.35.31.53.46c.36.29.7.6,1,.91s.65.62,1,.93l.48.49c.17.19.25.36.64.35a.57.57,0,0,0,.49-.32c.05-.25-.16-.38-.31-.53l-.48-.47c-.32-.32-.66-.62-1-.91s-.72-.61-1.1-.91a1.72,1.72,0,0,0-1.22-.6.25.25,0,0,0-.16.08Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.88,256.78c-.11-.11-.42,0-.64.12a3.18,3.18,0,0,0-.57.52c-.36.38-.69.77-1,1.16-.65.78-1.23,1.57-1.77,2.35-.26.38.57.26.81-.09q.69-1,1.47-2c.24-.31.5-.62.76-.93.12-.15.24-.3.37-.44l.22-.27a.61.61,0,0,1,.28-.19c.14-.07.12-.17.08-.22Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.88,221.63a30.88,30.88,0,0,0-2.38,4.42c-.87,1.75-1.78,3.5-2.87,5.26-1.94,3.13-5.3,7.95-10.07,9.72-4.61,1.72-7.85-.39-9.79-2a23.67,23.67,0,0,1-4.71-5.71c-2.26-3.51-4.3-7.54-9-9.34a11.05,11.05,0,0,0-8.53.24,20.63,20.63,0,0,0-8.09,6.34c-5.33,6.77-7.65,14.42-7.58,20.2,0,.19.61.1.65-.15,1-6.15,2.19-12.69,7.41-19.57,2.9-3.83,7.9-7.49,12.55-7a10.85,10.85,0,0,1,6.41,3c3.37,3.12,5,7.37,8,10.75,2.35,2.67,7.5,7.28,15.1,2.64a26.1,26.1,0,0,0,8-8.35c2.18-3.36,4.44-7.31,5.09-10.46,0,0,0-.11-.12,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.74,209.31a.46.46,0,0,0-.23.43c0,.28,0,.55-.05.81,0,.47,0,.93,0,1.39,0,.94,0,1.88,0,2.85,0,.2.6.11.61-.14,0-.94,0-1.85,0-2.76l0-1.36c0-.39.12-1-.2-1.22a0,0,0,0,0-.05,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.74,217.45a.48.48,0,0,0-.23.44c0,.27,0,.54-.05.81,0,.46,0,.92,0,1.38,0,.95,0,1.89,0,2.85,0,.21.6.11.61-.14,0-.93,0-1.84,0-2.75l0-1.37c0-.39.12-1-.2-1.22Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.74,225.6a.45.45,0,0,0-.23.43c0,.27,0,.54-.05.81,0,.47,0,.93,0,1.39,0,.94,0,1.88,0,2.84,0,.21.6.12.61-.14,0-.93,0-1.84,0-2.75l0-1.36c0-.4.12-1-.2-1.23a.05.05,0,0,0-.05,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.74,233.74a.46.46,0,0,0-.23.43c0,.28,0,.55-.05.81,0,.47,0,.93,0,1.39,0,.94,0,1.89,0,2.85,0,.21.6.11.61-.14,0-.94,0-1.85,0-2.76L69,235c0-.39.12-1-.2-1.22a0,0,0,0,0-.05,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.74,241.88a.48.48,0,0,0-.23.44c0,.27,0,.54-.05.81,0,.46,0,.92,0,1.38,0,1,0,1.89,0,2.85,0,.21.6.11.61-.14,0-.93,0-1.84,0-2.75l0-1.37c0-.39.12-1-.2-1.22Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.74,250a.45.45,0,0,0-.23.43c0,.27,0,.54-.05.81,0,.47,0,.93,0,1.39,0,.94,0,1.88,0,2.84,0,.21.6.12.61-.13,0-.94,0-1.85,0-2.76l0-1.36c0-.39.12-1-.2-1.23a.05.05,0,0,0-.05,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5,236.52c.08.1.21.11.39.12l.76,0c.54,0,1.09,0,1.64,0,1.1,0,2.21,0,3.28,0a.55.55,0,0,0,.42-.16c.09-.12,0-.22-.11-.22-1.07,0-2.16,0-3.26,0l-1.63,0H40a.73.73,0,0,0-.52.11s0,.08,0,.09Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9,236.52c.09.1.22.11.4.12l.75,0c.54,0,1.09,0,1.64,0,1.11,0,2.21,0,3.29,0a.53.53,0,0,0,.41-.16c.09-.12,0-.22-.11-.22-1.06,0-2.16,0-3.26,0l-1.63,0h-1a.73.73,0,0,0-.52.11.07.07,0,0,0,0,.09Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.31,236.52c.08.1.21.11.39.12l.76,0c.54,0,1.09,0,1.64,0,1.1,0,2.21,0,3.28,0a.53.53,0,0,0,.41-.16c.1-.12,0-.22-.11-.22-1.06,0-2.16,0-3.25,0l-1.63,0h-1a.71.71,0,0,0-.51.11s0,.08,0,.09Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.71,236.53a.55.55,0,0,0,.39.11l.76,0c.54,0,1.09,0,1.64,0,1.1,0,2.21,0,3.28,0a.55.55,0,0,0,.42-.16c.09-.12,0-.22-.11-.22-1.07,0-2.16,0-3.26,0l-1.63,0h-1a.73.73,0,0,0-.52.11.07.07,0,0,0,0,.1Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.11,236.52c.09.1.22.11.4.12l.75,0c.54,0,1.09,0,1.64,0,1.11,0,2.21,0,3.29,0a.53.53,0,0,0,.41-.16c.09-.12,0-.22-.11-.22-1.06,0-2.16,0-3.26,0l-1.63,0h-.95a.73.73,0,0,0-.52.11.07.07,0,0,0,0,.09Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.52,236.52c.08.1.21.11.39.12l.76,0c.54,0,1.09,0,1.64,0,1.1,0,2.21,0,3.28,0a.53.53,0,0,0,.41-.16c.1-.12,0-.22-.1-.22-1.07,0-2.16,0-3.26,0l-1.63,0h-1a.71.71,0,0,0-.51.11s0,.08,0,.09Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.61,236.62a26.12,26.12,0,0,0,2.67,0h2.83a1.58,1.58,0,0,0,.76-.08c.36-.23,0-.43-.29-.24.07,0,.26,0,.18-.07H41c-.44,0-.88,0-1.33,0-.26,0-.21.27-.07.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.64,236.62c.81.08,1.74,0,2.61,0h2.86a2.26,2.26,0,0,0,.72,0c.16-.05.25-.19.21-.26s-.21-.09-.37,0c.22-.07.14,0,0,0h-4.6c-.45,0-.9,0-1.37,0-.27,0-.22.27-.07.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4,236.62c.83.09,1.79,0,2.67,0h2.84a1.59,1.59,0,0,0,.76-.08c.35-.23,0-.43-.3-.24.07,0,.27,0,.18-.07H23.8c-.44,0-.87,0-1.32,0-.27,0-.22.27-.08.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.27,210.65a1.93,1.93,0,0,0,2.67.15,2,2,0,0,0,.73-1.56,1.56,1.56,0,0,0-.56-1.46,1.53,1.53,0,0,0-1.54-.17,1.88,1.88,0,0,0-1.08,1.2A3.71,3.71,0,0,0,62,212a3.46,3.46,0,0,0,3.58,1.47c.27,0,.26-.29.1-.3a3.53,3.53,0,0,1-3.52-4.13,1.94,1.94,0,0,1,.24-.78.58.58,0,0,1,.75-.3,1.23,1.23,0,0,1,.85,1.22c0,.36,0,1.38-.9,1.62a1.72,1.72,0,0,1-1.5-.38c-.11-.07-.42.06-.35.2Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.76,231.86a3.4,3.4,0,0,1,1.74,1,2.17,2.17,0,0,1,.49.86.92.92,0,0,1-.24,1,.72.72,0,0,1-1,0c-.15-.11-.76-.44-.42-.74a3,3,0,0,1,.64-.32,4.77,4.77,0,0,1,.77-.28,3.46,3.46,0,0,1,1.36-.12,2.19,2.19,0,0,1,1.72,1.09c.09.18.7,0,.6-.24a2.48,2.48,0,0,0-2.13-1.24,4.81,4.81,0,0,0-1.85.24,7.53,7.53,0,0,0-.85.34,2.54,2.54,0,0,0-.79.48c-.41.44,0,.75.26.94a1.52,1.52,0,0,0,1.24.46,1.55,1.55,0,0,0,1.16-.77,1.26,1.26,0,0,0-.08-1.18,3.32,3.32,0,0,0-2.46-1.71c-.22,0-.29.22-.14.26Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.69,230.67a1.24,1.24,0,0,0-1-.09,2.54,2.54,0,0,0-.92.45,2.25,2.25,0,0,0-.81,1.6c0,.28-.05.58.15.76a.85.85,0,0,0,.76.15,2.35,2.35,0,0,0,1.45-1,2,2,0,0,0,.35-1.69l-.66.2c.18.7.41,1.43,1.25,1.7a1.54,1.54,0,0,0,1.23-.13c.49-.28.69-.74.58-1,0-.08-.29-.13-.4,0s-.25.63-.56.72a.8.8,0,0,1-.69-.18,2.07,2.07,0,0,1-.75-1.36c-.05-.2-.73,0-.66.2a1.72,1.72,0,0,1-.26,1.44c-.2.29-.7.78-1,.59s-.14-.49-.1-.74a2,2,0,0,1,.25-.8,1.35,1.35,0,0,1,.58-.55,1.91,1.91,0,0,1,1.08-.11.2.2,0,0,0,.17-.09c.05-.07,0-.11,0-.15Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--graphics--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.79,27.37c-.6,4.54-.28,8.85-.33,13.2s-.09,8.87-.12,13.31-.07,8.85-.11,13.27q0,3.39-.05,6.76c0,1.13,0,2.25,0,3.38,0,.95-.24,2.06.24,2.78.05.08.41.08.48-.11a8,8,0,0,0,.28-3.13l0-3.38q0-3.37.05-6.76,0-6.51.1-13l.09-13c0-4.45.45-9.18-.13-13.39,0-.14-.48-.12-.51.1Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.86,36.8c-.21,3.42.16,6.67.26,10s.17,6.59.2,9.91,0,6.43,0,9.67-.5,6.92-.18,10.12c0,.24.79,0,.83-.26a73.21,73.21,0,0,0,.3-10q.06-5.09,0-10.13t-.21-9.9a71.57,71.57,0,0,0-.57-9.58c0-.19-.62-.09-.63.18Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.61,39.68c6.77.24,13.86,0,20.8,0l20.91-.08c.49,0,1.19-.7.63-.7L400,39c-7,0-13.92-.12-21.11.19-.36,0-.68.46-.32.47Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.29,71.83c11.27.6,9.63.37,21.35.34,11.54,0,23.14-.15,34.72-.22q10.2-.08,20.36-.08c.47,0,1.19-.67.65-.67-23.24,0-35.86.4-59,.31-6.79,0-10.75-.26-17.63-.14-.38,0-.84.44-.41.46Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.51,20.32c1.63,5.07,4.76,9.43,7.84,13.67a60.65,60.65,0,0,0,10.94,11.08,96.36,96.36,0,0,0,30.59,16.19c6.68,2.21,13.81,4.52,22.31,4.68.34,0,.61-.33.29-.38-3.28-.57-6.76-.91-10-1.61-3.51-.77-6.86-1.72-10.12-2.75a110.75,110.75,0,0,1-16.66-6.72,81.17,81.17,0,0,1-25.74-20c-3.73-4.41-6.34-9.33-9-14.38-.07-.15-.61-.05-.54.18Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.57,33.25A10.9,10.9,0,0,0,405.46,31a10.09,10.09,0,0,0,.67-1.18q.15-.32.27-.63c.08-.18.24-.46.13-.57a.48.48,0,0,0-.6.12,1.67,1.67,0,0,0-.27.6c-.08.19-.17.38-.26.57a10.78,10.78,0,0,1-.63,1.14,11.7,11.7,0,0,1-1.7,2.05c-.29.28.23.36.5.11Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.89,29a1.28,1.28,0,0,0,.31.64,6.42,6.42,0,0,0,.42.6,6.73,6.73,0,0,0,1,1c.16.13.34.38.7.31a.62.62,0,0,0,.46-.28c.09-.17-.06-.24-.16-.31a7.9,7.9,0,0,1-1.07-.91c-.18-.19-.36-.38-.53-.58a3.18,3.18,0,0,0-.57-.7c-.13-.1-.61,0-.59.27Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,32.36c-.4.34-.18.66-.05.9s.33.64.51,1A15.36,15.36,0,0,0,384.66,36c.13.18.59.05.84-.22a6.07,6.07,0,0,0,1-1.84,4.68,4.68,0,0,0,.64-1.87c0-.33-.94,0-.92.31a4.41,4.41,0,0,1-.59,1.72,5.55,5.55,0,0,1-.93,1.68l.84-.22a19,19,0,0,1-1.16-1.66c-.32-.52-.61-1.06-.95-1.57v.15l0-.09c.1-.2-.32-.22-.52,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.4,59.22a3.33,3.33,0,0,0,.79.8l.83.72.83.71.42.35c.13.11.34.22.4.38l.13-.3-.07.07.5-.22h-.11c-.16,0-.47.14-.48.3.72,0,1-.16.93-.38a.34.34,0,0,0-.08-.09l-.22-.19-.48-.38-.9-.73-.9-.71a4.18,4.18,0,0,0-1-.66c-.15-.06-.73.12-.63.32Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.43,58.88c-1,1-1.86,2-2.78,2.95-.22.24-.69.66-.33.73a.93.93,0,0,0,.74-.32c.11-.1.2-.21.3-.32l1.36-1.5c.44-.48.87-1,1.27-1.46.25-.3-.29-.35-.56-.08Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.58,47.27a13.83,13.83,0,0,0,2.58,3.45c.21.22,1.06-.3.82-.55-1-1-1.84-2.15-2.84-3.17-.12-.12-.65.06-.56.27Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.31,47.06a9,9,0,0,0-.84,1.54c-.25.47-.53.94-.83,1.42s-.58.88-.91,1.32a8.7,8.7,0,0,1-1.21,1.42c-.28.25,0,.41.32.26-.21,0-.26.06-.14,0l.09,0a1.33,1.33,0,0,0,.32-.15,1.85,1.85,0,0,0,.42-.36,8.14,8.14,0,0,0,.61-.73c.41-.53.79-1,1.13-1.58s.67-1.07,1-1.6q.24-.46.45-.93a1.51,1.51,0,0,0,.21-.68c0-.14-.4-.18-.58.05Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.17,50.09c.23,0,.45,0,.67,0s.44,0,.66,0c.4,0,.79,0,1.19,0a.81.81,0,0,0,.55-.26c.12-.17,0-.24-.16-.25h-1.15l-.76,0-.85.1a.47.47,0,0,0-.36.2c0,.12.08.17.21.17Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.36,51.61a6,6,0,0,0,.74,0h.71l1.38,0a1,1,0,0,0,.63-.29c.14-.16.08-.31-.11-.3l-1.53.06a14.56,14.56,0,0,0-1.57.12.62.62,0,0,0-.37.22c-.06.11,0,.19.12.2Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.42,48.06a1.76,1.76,0,0,0-2.09-.47,3.05,3.05,0,0,0-1.92,1.8,1.74,1.74,0,0,0,.33,2.11,2.74,2.74,0,0,0,2.43.72,4.42,4.42,0,0,0,1.8-.78c.43-.36.64-.83.31-1a.53.53,0,0,0-.56.15,2.3,2.3,0,0,1-.31.63,1.63,1.63,0,0,1-.61.29,1.7,1.7,0,0,1-1.15,0,4.12,4.12,0,0,1-1-.54,1.2,1.2,0,0,1-.52-.86,2.17,2.17,0,0,1,.18-1,1.79,1.79,0,0,1,.61-.85,1.31,1.31,0,0,1,.82-.21,2.14,2.14,0,0,1,1.07.31c.17.09.7-.11.58-.32Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.57,49.52c.53-.1,1.42-.24,1.67,0s-.58.93-1,1.15-.16.38.06.37c1.15-.09,2,.51,1.9,1.38a.83.83,0,0,1-.85.76c-.59-.06-.71-.5-1.15-.69-.08,0-.37,0-.45.13-.29.65.51,1,1.17,1.07a2.16,2.16,0,0,0,1.9-1,1.23,1.23,0,0,0-.28-1.55,2.45,2.45,0,0,0-2-.56c0,.13,0,.25.05.37.71-.36,1.65-1.25,1.4-1.67s-1.6-.34-2.49,0c-.31.1-.09.31.09.28Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.71,75.22v0a.39.39,0,0,0,.39-.06c.13-.12.06-.21,0-.24a1.48,1.48,0,0,0-.77,0,2.24,2.24,0,0,0-.71.25,1.72,1.72,0,0,0-.8.83,1.28,1.28,0,0,0,.38,1.53,2,2,0,0,0,2.05.2,1.32,1.32,0,0,0,.47-2.38,1.81,1.81,0,0,0-1.29-.36c-.26,0-.5.3-.33.38s.52.16.73.28a1.29,1.29,0,0,1,.5.45.93.93,0,0,1,.17.62.74.74,0,0,1-.27.54.66.66,0,0,1-.48.16,1.3,1.3,0,0,1-.63-.17,1.12,1.12,0,0,1-.63-1,.9.9,0,0,1,.25-.61,1.58,1.58,0,0,1,1.21-.3,2.91,2.91,0,0,0,0-.31l-.23.05a.11.11,0,0,0,0,.21Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.15,78c-.22-.46-1.18-.4-2,.15a1.81,1.81,0,0,0-.85,1.46,1.55,1.55,0,0,0,.68,1.2,2.26,2.26,0,0,0,1.66.44,3,3,0,0,0,2.25-1.35c.16-.31-.55-.18-.76.09a1.64,1.64,0,0,1-2.65-.06,1.08,1.08,0,0,1-.13-1.21,1,1,0,0,1,.43-.42.9.9,0,0,1,.25-.08.86.86,0,0,1,.54,0,.38.38,0,0,0,.36,0c.14-.07.22-.17.18-.25Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.87,74.86c-.1.26.14.34.31.47s.47.34.72.5c.51.33,1,.65,1.55,1l1.47.88.74.44a1.15,1.15,0,0,0,1,.29c.38-.07.54-.45.19-.41h-.12c.11,0,.36.08.34-.07s-.09-.08-.13-.11l-.38-.21-.74-.43c-.51-.29-1-.58-1.52-.88l-1.53-.88c-.24-.14-.49-.27-.74-.4a1.65,1.65,0,0,0-.87-.31c-.09,0-.22,0-.25.14Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448,73.78c-.82.87-1.54,1.75-2.41,2.6-.37.38-.76.74-1.17,1.1s-.91.77-1.34,1.16c-.16.15-.09.28,0,.31a.83.83,0,0,0,.57-.18,22.4,22.4,0,0,0,2.69-2.4,16.52,16.52,0,0,0,2.16-2.53c.15-.23-.32-.3-.54-.06Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Molecules--inject-97",
    d: "M70.75,62.51a1.89,1.89,0,0,0-1-.07l-1.75-4a1.89,1.89,0,0,0,.66-.88A1.92,1.92,0,0,0,65,56.25a1.87,1.87,0,0,0-.1.84l-4.49,1.4a2.88,2.88,0,0,0-3.5-1.5L54.28,51.6a2.85,2.85,0,0,0,1.08-1.37,2.9,2.9,0,0,0,0-1.86l3-1.43a1.89,1.89,0,0,0,.84.63,1.92,1.92,0,1,0-1.12-2.46,1.86,1.86,0,0,0-.07,1.09l-3,1.43a2.89,2.89,0,0,0-1.4-1.12,3.2,3.2,0,0,0-.61-.15V42.87a1.93,1.93,0,0,0,1.38-1.2,1.92,1.92,0,0,0-3.59-1.34,2.07,2.07,0,0,0-.12.64L49,41.31a1.91,1.91,0,1,0,0,1.45,1.8,1.8,0,0,0,.11-.64l1.69-.35a1.87,1.87,0,0,0,1.08,1,1.34,1.34,0,0,0,.27.07v3.5a2.89,2.89,0,0,0-2.29,1.85,3,3,0,0,0-.17.76l-7.05.41a2.9,2.9,0,0,0-1.82-2.13,3,3,0,0,0-.77-.17l-.41-7.21a1.91,1.91,0,0,0,.16-3.63,1.92,1.92,0,0,0-2.47,1.13,1,1,0,0,0,0,.18l-4.62-.2a2.87,2.87,0,1,0-.16,1.3,2.85,2.85,0,0,0,.13-.48l4.61.2a1.91,1.91,0,0,0,1.21,1.46,2.42,2.42,0,0,0,.36.1l.41,7.2a2.88,2.88,0,0,0-2,4.22L34,53.9a1.8,1.8,0,0,0-.57-.34,1.93,1.93,0,1,0,1.07,1L37.86,52a2.7,2.7,0,0,0,1,.65,2.67,2.67,0,0,0,1.11.18l.62,3.4a1.89,1.89,0,0,0-1.06,1.1A1.92,1.92,0,1,0,42,56.21a2,2,0,0,0-.59-.11l-.62-3.4A2.87,2.87,0,0,0,42.59,51a2.67,2.67,0,0,0,.17-.77l7.06-.41A2.87,2.87,0,0,0,53.54,52l2.66,5.39a2.92,2.92,0,0,0-1.08,1.38,2.88,2.88,0,0,0-.06,1.81l-4.2,1.9A1.86,1.86,0,0,0,50,61.8a1.91,1.91,0,1,0,1.13,2.46,2,2,0,0,0,.07-1.07l4.2-1.9a2.86,2.86,0,0,0,1.42,1.15,1.9,1.9,0,0,0,.39.11l-.27,3.58a1.9,1.9,0,1,0,.94.09l-.12,0L58,62.62a2.88,2.88,0,0,0,2.65-3.35l4.48-1.4a1.93,1.93,0,0,0,1,.85,2,2,0,0,0,1,.08l1.75,4a1.81,1.81,0,0,0-.66.87,1.92,1.92,0,1,0,2.46-1.13Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--molecules--inject-97"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M319.44,56.47l-5.63-9.76,5.48-9.49h11.18l.17.29L336.1,47l-5.48,9.49H319.44ZM314.54,47l5.15,8.91h10.38l5.3-9.18-5.15-8.91H319.84Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M335.86,65.22l-5.15-8.91,5.3-9.18h10.38l.06.09c0-.11.07-.22.11-.33s.08-.18.12-.27l0-.08H335.46L330,56.05l5.47,9.47.17.29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M319.44,75.14l-5.64-9.76,5.49-9.49h11.18l5.63,9.76-5.48,9.49H319.44Zm-4.9-9.49,5.15,8.91h10.38l5.29-9.18-5.14-8.91H319.84Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M303.27,84.48l-5.63-9.76,5.48-9.5H314.3L319.94,75l-5.49,9.5H303.27ZM298.38,75l5.14,8.91H313.9l5.3-9.17-5.15-8.92H303.67Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M313.47,84.48l0-.07a3,3,0,0,1,.62-.46l.12-.06H303.12l-5.48,9.5,5.62,9.74.33-.53,0,0h-.09l-5.14-8.92,5.29-9.17Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M298.13,74.56H298c0,.19-.07.39-.12.58h0L303,84.05l-5.3,9.18H287.35l-.09-.14a1.35,1.35,0,0,1-.2.5l-.05.06.09.16h11.18l5.48-9.49Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M333.32,56.18a3,3,0,1,1-3-3A3,3,0,0,1,333.32,56.18Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.71,46.84a3,3,0,1,1-3-3A3,3,0,0,1,338.71,46.84Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.54,74.85a3,3,0,1,1-3-3A3,3,0,0,1,322.54,74.85Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.37,84.19a3,3,0,1,1-3-3A3,3,0,0,1,306.37,84.19Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,74.85a3,3,0,1,1-3-3A3,3,0,0,1,301,74.85Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.88,37.51a1.32,1.32,0,1,1-1.32-1.32A1.32,1.32,0,0,1,320.88,37.51Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.66,37.51a1.32,1.32,0,1,1-1.32-1.32A1.31,1.31,0,0,1,331.66,37.51Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.49,46.84a1.32,1.32,0,1,1-1.32-1.31A1.32,1.32,0,0,1,315.49,46.84Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.88,56.18a1.32,1.32,0,1,1-1.32-1.32A1.32,1.32,0,0,1,320.88,56.18Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.83,46.84a1.32,1.32,0,1,1-1.32-1.31A1.32,1.32,0,0,1,347.83,46.84Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.05,65.52a1.32,1.32,0,1,1-1.32-1.32A1.32,1.32,0,0,1,337.05,65.52Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.66,74.85a1.32,1.32,0,1,1-1.32-1.31A1.32,1.32,0,0,1,331.66,74.85Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.49,65.52a1.32,1.32,0,1,1-1.32-1.32A1.32,1.32,0,0,1,315.49,65.52Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.71,65.51a1.32,1.32,0,1,1-1.31-1.31A1.32,1.32,0,0,1,304.71,65.51Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.49,84.19a1.32,1.32,0,1,1-1.31-1.32A1.31,1.31,0,0,1,315.49,84.19Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.71,102.86a1.32,1.32,0,1,1-1.31-1.32A1.31,1.31,0,0,1,304.71,102.86Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.54,93.52a1.32,1.32,0,1,1-1.31-1.32A1.32,1.32,0,0,1,288.54,93.52Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.32,93.52A1.32,1.32,0,1,1,298,92.2,1.32,1.32,0,0,1,299.32,93.52Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--graduation-cap--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.15,54.28l-4-12.39h0c-.83-2.38.45-5.46,4-8.65,7.08-6.31,20.48-10.67,29.92-9.74,4.77.47,7.62,2.2,8.35,4.61h0l4,12.34c.81,2.38-.06,6.71-3.63,9.88-7.09,6.31-20.48,10.67-29.92,9.75-4.71-.47-8-3.42-8.73-5.78h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.57 17.5 147.94 25.21 123.08 52.85 86.71 45.15 111.57 17.5",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.94 25.21 148.35 26.47 123.49 54.12 123.08 52.85 147.94 25.21",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.71 45.15 87.12 46.41 123.49 54.12 123.08 52.85 86.71 45.15",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.59 37.33 124.11 56.01 101.47 49.45 123.49 54.12 138.59 37.33",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.25,45.76l11-12.42a.69.69,0,0,1,1.11.82l-.07.11-11,12.43",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.44,65.71a2.38,2.38,0,0,0,2.08-.68l5.28,10.45c.67,2.08-4.72,3.84-5.4,1.76Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.39,72,111,78.17c-.13,0-.26,0-.38,0Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.92,77.27,110,67.7,114.23,77Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.77,77.86l-.33.11-2.37-7.84Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.48,65.23a.7.7,0,0,0,.44-.88l-5.08-15.59a2.1,2.1,0,0,1,.45-2.06l-1-.94a3.5,3.5,0,0,0-.73,3.43l5.07,15.6A.71.71,0,0,0,108.48,65.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.72,64.09a1.54,1.54,0,1,0-1,1.94A1.55,1.55,0,0,0,109.72,64.09Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.84,65.12a1.19,1.19,0,0,0,1.8,0,1.27,1.27,0,0,0-.65-2.08,1.53,1.53,0,0,1,1.73,1,1.54,1.54,0,0,1-1,1.94A1.52,1.52,0,0,1,106.84,65.12Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--paper-plane--inject-97"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "56.72 112.71 91.48 92.16 67.35 118.99 56.72 112.71",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.48 92.16 52.65 108.39 42.01 102.11 91.48 92.16",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.65 108.39 55.01 118.39 56.72 112.71 91.48 92.16 52.65 108.39",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.65 108.39 55.01 118.39 56.72 112.71 91.48 92.16 52.65 108.39",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.01 118.39 60.26 114.8 56.72 112.71 55.01 118.39",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.72 112.71 60.26 114.8 59.42 115.37 56.72 112.71",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.63,115.34a.51.51,0,0,1-.27-.94l1.32-.8a.51.51,0,1,1,.52.88l-1.3.78A.56.56,0,0,1,47.63,115.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.24,203.55a.54.54,0,0,1-.37-.16c-.67-.72-1.34-1.5-2-2.29a.51.51,0,0,1,.79-.65c.64.79,1.29,1.54,1.94,2.24a.51.51,0,0,1,0,.72A.52.52,0,0,1,28.24,203.55Zm-4.91-6.3a.52.52,0,0,1-.43-.23c-.55-.84-1.08-1.7-1.58-2.57a.51.51,0,1,1,.88-.51c.49.85,1,1.7,1.56,2.52a.52.52,0,0,1-.15.71A.57.57,0,0,1,23.33,197.25Zm-3.87-7A.5.5,0,0,1,19,190c-.42-.91-.82-1.85-1.19-2.78a.51.51,0,1,1,1-.37c.36.91.75,1.83,1.16,2.73a.5.5,0,0,1-.25.67A.41.41,0,0,1,19.46,190.27Zm-2.77-7.48a.51.51,0,0,1-.49-.37c-.28-1-.53-1.95-.75-2.93a.51.51,0,0,1,1-.23c.21,1,.46,1.93.73,2.88a.52.52,0,0,1-.35.63ZM15.1,175a.51.51,0,0,1-.5-.45c-.12-1-.22-2-.28-3a.5.5,0,0,1,.48-.54.49.49,0,0,1,.54.47c.06,1,.15,2,.27,2.95a.52.52,0,0,1-.45.57Zm-.33-8h0a.5.5,0,0,1-.49-.52c0-1,.1-2,.19-3A.52.52,0,0,1,15,163a.51.51,0,0,1,.46.55c-.1,1-.16,2-.2,3A.49.49,0,0,1,14.77,167Zm.87-7.93h-.09a.5.5,0,0,1-.41-.59c.17-1,.38-2,.6-3a.51.51,0,1,1,1,.23c-.22,1-.42,1.94-.59,2.91A.5.5,0,0,1,15.64,159.06Zm1.91-7.75a.39.39,0,0,1-.15,0,.5.5,0,0,1-.33-.64c.3-1,.64-1.91,1-2.85a.51.51,0,1,1,1,.36c-.34.92-.67,1.86-1,2.8A.5.5,0,0,1,17.55,151.31Zm2.95-7.41a.54.54,0,0,1-.22-.05.51.51,0,0,1-.24-.68c.43-.9.89-1.8,1.38-2.69a.5.5,0,0,1,.69-.2.52.52,0,0,1,.2.69c-.48.87-.93,1.76-1.35,2.64A.52.52,0,0,1,20.5,143.9ZM24.44,137a.47.47,0,0,1-.28-.09.5.5,0,0,1-.15-.7c.55-.83,1.13-1.66,1.73-2.48a.51.51,0,0,1,.71-.11.5.5,0,0,1,.11.71c-.59.8-1.16,1.62-1.7,2.44A.51.51,0,0,1,24.44,137Zm4.82-6.36a.54.54,0,0,1-.33-.12.51.51,0,0,1-.05-.72c.65-.75,1.33-1.5,2-2.24a.52.52,0,0,1,.72,0,.51.51,0,0,1,0,.72c-.68.73-1.35,1.47-2,2.21A.52.52,0,0,1,29.26,130.6Zm5.58-5.72a.51.51,0,0,1-.38-.16.52.52,0,0,1,0-.72c.74-.68,1.5-1.34,2.27-2a.5.5,0,0,1,.72.06.51.51,0,0,1-.06.71c-.76.65-1.51,1.3-2.24,2A.5.5,0,0,1,34.84,124.88ZM41,119.8a.51.51,0,0,1-.31-.91c.81-.6,1.62-1.18,2.45-1.76a.51.51,0,1,1,.58.84c-.82.57-1.63,1.15-2.42,1.73A.49.49,0,0,1,41,119.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.23,207.74a.46.46,0,0,1-.23-.06,9.56,9.56,0,0,1-1.36-.85.51.51,0,0,1,.6-.83,8.61,8.61,0,0,0,1.21.77.5.5,0,0,1,.23.68A.5.5,0,0,1,33.23,207.74Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--paper-plane--inject-97"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "413.11 149.69 454.04 129.22 470.35 136.43 413.11 149.69",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.11 149.69 449.17 125.59 442.71 116.31 413.11 149.69",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "449.17 125.59 448.49 132 413.11 149.69 449.17 125.59",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "449.17 125.59 448.49 132 413.11 149.69 449.17 125.59",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.17,121.75a.5.5,0,0,1-.34-.13.52.52,0,0,1-.05-.72c.34-.38.67-.76,1-1.15a.51.51,0,0,1,.72-.06.5.5,0,0,1,.06.71c-.33.4-.66.78-1,1.17A.49.49,0,0,1,458.17,121.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.28,116.68a.5.5,0,0,1-.31-.1.51.51,0,0,1-.1-.71c.6-.8,1.19-1.6,1.76-2.41a.5.5,0,0,1,.71-.12.52.52,0,0,1,.12.71c-.58.81-1.17,1.63-1.78,2.43A.49.49,0,0,1,462.28,116.68Zm4.5-6.59a.5.5,0,0,1-.26-.08.51.51,0,0,1-.17-.7c.52-.85,1-1.7,1.5-2.56a.51.51,0,1,1,.89.49c-.48.88-1,1.74-1.52,2.6A.51.51,0,0,1,466.78,110.09Zm3.8-7a.44.44,0,0,1-.22,0,.5.5,0,0,1-.24-.67c.42-.91.82-1.82,1.2-2.72a.5.5,0,0,1,.66-.28.52.52,0,0,1,.28.67c-.38.91-.79,1.84-1.22,2.76A.52.52,0,0,1,470.58,103.06Zm2.94-7.42a.45.45,0,0,1-.16,0A.51.51,0,0,1,473,95c.31-1,.6-1.9.85-2.84a.51.51,0,0,1,.63-.36.49.49,0,0,1,.35.62c-.25,1-.54,1.93-.86,2.9A.51.51,0,0,1,473.52,95.64Zm2-7.74h-.09a.5.5,0,0,1-.41-.59c.18-1,.33-2,.45-2.93a.51.51,0,0,1,.57-.44.5.5,0,0,1,.44.57c-.12,1-.28,2-.46,3A.5.5,0,0,1,475.47,87.9Zm.87-7.93h0a.5.5,0,0,1-.48-.53c0-.77,0-1.55,0-2.33v-.64a.5.5,0,0,1,.5-.51h0a.51.51,0,0,1,.51.5v.65c0,.79,0,1.58,0,2.37A.51.51,0,0,1,476.34,80Zm-.22-8a.5.5,0,0,1-.5-.46c-.1-1-.22-2-.36-3a.51.51,0,0,1,1-.15c.15,1,.27,2,.36,3a.51.51,0,0,1-.46.56Zm-1.26-7.88a.52.52,0,0,1-.5-.39c-.22-1-.47-1.93-.75-2.87a.51.51,0,1,1,1-.29c.28,1,.54,1.95.76,2.93a.5.5,0,0,1-.38.61Zm-2.39-7.61a.51.51,0,0,1-.47-.32c-.37-.91-.77-1.83-1.19-2.72a.51.51,0,0,1,.25-.68.52.52,0,0,1,.68.25c.42.91.83,1.84,1.2,2.77a.5.5,0,0,1-.28.66A.41.41,0,0,1,472.47,56.5Zm-3.55-7.15a.5.5,0,0,1-.43-.25c-.51-.84-1.05-1.68-1.6-2.49a.51.51,0,0,1,.84-.58c.56.83,1.11,1.69,1.63,2.55a.51.51,0,0,1-.18.7A.48.48,0,0,1,468.92,49.35Zm-4.62-6.51a.51.51,0,0,1-.39-.18c-.63-.76-1.29-1.51-2-2.22a.52.52,0,0,1,0-.72.5.5,0,0,1,.72,0c.68.73,1.36,1.49,2,2.27a.51.51,0,0,1-.06.72A.57.57,0,0,1,464.3,42.84Zm-5.55-5.73a.48.48,0,0,1-.34-.13c-.74-.65-1.51-1.29-2.28-1.9a.52.52,0,0,1-.08-.72.51.51,0,0,1,.72-.08c.78.62,1.56,1.27,2.31,1.94a.51.51,0,0,1-.33.89Zm-6.36-4.82a.57.57,0,0,1-.28-.08c-.84-.54-1.7-1.05-2.55-1.51a.52.52,0,0,1-.2-.69.52.52,0,0,1,.69-.21c.87.48,1.75,1,2.61,1.55a.5.5,0,0,1,.15.7A.5.5,0,0,1,452.39,32.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.23,28.72a.4.4,0,0,1-.15,0,9.8,9.8,0,0,0-1.4-.35.5.5,0,0,1-.43-.57.51.51,0,0,1,.58-.43,9.66,9.66,0,0,1,1.56.38.5.5,0,0,1,.33.64A.51.51,0,0,1,445.23,28.72Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Flask--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.05,161a17.16,17.16,0,0,1,14-6.71c4.94.38,6.67,4,3.88,8.08a17.19,17.19,0,0,1-14,6.71C257,168.71,255.26,165.09,258.05,161Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.05,161a17.16,17.16,0,0,1,14-6.71c4.94.38,6.67,4,3.88,8.08a17.19,17.19,0,0,1-14,6.71C257,168.71,255.26,165.09,258.05,161Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M259.12,134.23l-6.62-13.81-8.62,4.16,6.61,13.79a16.91,16.91,0,1,0,8.63-4.14Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.12,134.23l-6.62-13.81-8.62,4.16,6.61,13.79a16.91,16.91,0,1,0,8.63-4.14Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.35 134.75 252.48 121.8 251.95 122.29 258 134.91 258.35 134.75",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.77,123.09s-.49,1.2-3.93,2.85-4.68,1.3-4.68,1.3l-1.28-2.66,8.62-4.16Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.09,121.66a10.31,10.31,0,0,1-3.94,2.85,10.55,10.55,0,0,1-4.68,1.3l-.59-1.23,8.62-4.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.59,117.89a12.77,12.77,0,0,0-7.55,3.62c-1.64,1.83-1,3.21,1.47,3.07a12.7,12.7,0,0,0,7.55-3.62C253.77,119.1,253.11,117.72,250.59,117.89Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.59,117.89a12.77,12.77,0,0,0-7.55,3.62c-1.64,1.83-1,3.21,1.47,3.07a12.7,12.7,0,0,0,7.55-3.62C253.77,119.1,253.11,117.72,250.59,117.89Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.61,122.74c.5.11,2,.15,5-1.71,2.61-1.64,1.56-2.86-.74-2A11.82,11.82,0,0,0,244.61,122.74Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.47,118.94a11.48,11.48,0,0,0-4.89,2.35c-1.14,1-.84,1.65.67,1.4a11.57,11.57,0,0,0,4.89-2.35C251.33,119.3,251,118.67,249.47,118.94Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.47,118.94a11.48,11.48,0,0,0-4.89,2.35c-1.14,1-.84,1.65.67,1.4a11.57,11.57,0,0,0,4.89-2.35C251.33,119.3,251,118.67,249.47,118.94Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.06,121a3.27,3.27,0,0,0,.93-1.62c-1.15,2.32-5.76,4.29-7.94,4.55s-2.85-1-2.39-1.9c-1.12,1.58-.38,2.71,1.85,2.59A12.7,12.7,0,0,0,252.06,121Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.47,118.94a10.74,10.74,0,0,0-2.57.88l.95,2a10.47,10.47,0,0,0,2.29-1.45C251.33,119.3,251,118.67,249.47,118.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.59,117.89a13.1,13.1,0,0,0-6.29,2.49c.2-.1,3.81-2.35,6.3-2.28,2.18.05,2.48.89,2.28,1.64C253.35,118.54,252.52,117.76,250.59,117.89Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.28,144.47a14.92,14.92,0,1,1-28.37,7,8.49,8.49,0,0,1,1.71-5.06c3.59-5.24,11.64-9.1,18-8.62a8.48,8.48,0,0,1,5,1.83A14.8,14.8,0,0,1,275.28,144.47Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.28,144.47a14.92,14.92,0,1,1-28.37,7,8.49,8.49,0,0,1,1.71-5.06c3.59-5.24,11.64-9.1,18-8.62a8.48,8.48,0,0,1,5,1.83A14.8,14.8,0,0,1,275.28,144.47Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.28,144.47a14.93,14.93,0,0,0-3.61-4.76C271.49,142,271,149,271,149c2.34,4.89,1.95,13.11-2.71,15.35A14.93,14.93,0,0,0,275.28,144.47Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.58,148.21c-3.59,5.25-11.64,9.11-18,8.63-4.16-.32-6.55-2.43-6.69-5.33a8.49,8.49,0,0,1,1.71-5.06c3.59-5.24,11.64-9.1,18-8.62a8.48,8.48,0,0,1,5,1.83C273.79,141.58,273.93,144.77,271.58,148.21Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.66,154.47c-4.75-1.71-4.42-7.54-2.72-9.66a16.63,16.63,0,0,0-1.32,1.64,8.49,8.49,0,0,0-1.71,5.06c.14,2.9,2.53,5,6.69,5.33,5.37.41,12-2.3,16-6.33C264.52,154,257.34,156.17,252.66,154.47Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.66,138.33l-.77-1.6-6.37-13.29a11.75,11.75,0,0,1-3.08,1l6.71,14a15.64,15.64,0,0,0-4.81,19.09c3.6,7.49,11.8,12.15,21.3,7.59C253.77,167.09,244.87,149.42,255.66,138.33Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      mixBlendMode: "hard-light"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Atom--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.64,122a3.32,3.32,0,1,1-4.7.09A3.32,3.32,0,0,1,379.64,122Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.64,122a3.32,3.32,0,1,1-4.7.09A3.32,3.32,0,0,1,379.64,122Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,126.56a3.25,3.25,0,0,1-3.93-2,3.33,3.33,0,1,0,6.4-1.35C380.69,124.05,379.72,126,378,126.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.22,115.84a5,5,0,1,1-7.12.15A5,5,0,0,1,376.22,115.84Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.65,122.67a4.9,4.9,0,0,1-5.94-3.08,5,5,0,1,0,9.67-2C377.8,118.89,376.34,121.84,373.65,122.67Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.77,125a5,5,0,1,1-7.11.15A5,5,0,0,1,375.77,125Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.2,131.85a4.91,4.91,0,0,1-5.94-3.09,5,5,0,1,0,9.67-2C377.35,128.06,375.89,131,373.2,131.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.63,122.39a3.33,3.33,0,1,1-4.7.1A3.33,3.33,0,0,1,369.63,122.39Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.63,122.39a3.33,3.33,0,1,1-4.7.1A3.33,3.33,0,0,1,369.63,122.39Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.93,126.91a3.25,3.25,0,0,1-3.93-2,3.33,3.33,0,1,0,6.4-1.35C370.67,124.41,369.71,126.36,367.93,126.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.52,114.59c-11.46-5.08-21.35-6.91-24.59-4.54a2.68,2.68,0,0,0-1.12,2.64c.5,4.71,10.2,12.76,22.51,19a4.12,4.12,0,0,1-.54-.86c-11.82-6.14-21-13.77-21.46-18.23a2.2,2.2,0,0,1,.57-1.87,2,2,0,0,1,.34-.31c1.53-1.11,4.77-1.19,9-.37a72.76,72.76,0,0,1,15.07,5c14.46,6.41,26.68,15.83,27.23,21a2.22,2.22,0,0,1-.91,2.18c-3.05,2.22-12.95.32-24.09-4.61l-.18-.08h0a4.24,4.24,0,0,1-1,.1l1,.46c11.48,5.08,21.36,6.91,24.6,4.55a2.93,2.93,0,0,0,.41-.36,2.71,2.71,0,0,0,.71-2.29c-.2-1.9-1.9-4.36-4.67-7C389.4,124.23,380.93,118.76,371.52,114.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.81,95.79c-5.07,1.75-11.66,15.95-14.68,31.65-2.37,12.32-1.93,22.37,1.11,25a2.71,2.71,0,0,0,2.82.5,7.22,7.22,0,0,0,2.7-1.93c4.51-4.71,9.47-16.7,12-29.73,2.38-12.32,1.94-22.36-1.09-25A2.69,2.69,0,0,0,377.81,95.79Zm3.43,25.38c-.19,1-.38,1.9-.59,2.85a3.4,3.4,0,0,1-.52,2.23c-3.29,13.41-8.86,24.68-13.23,26.19a2.2,2.2,0,0,1-2.33-.4c-2.84-2.47-3.23-12.54-.93-24.5,2.49-13,7.37-24.85,11.77-29.44A6.92,6.92,0,0,1,378,96.27a2.18,2.18,0,0,1,2.32.41l.11.1C383.16,99.42,383.5,109.37,381.24,121.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,114.88c-15.5,3.94-29.29,11.36-30.75,16.51a2.73,2.73,0,0,0,.67,2.8c2.8,2.87,12.85,2.73,25-.37l1.19-.3a4.66,4.66,0,0,1-.89-.3l-.42.1c-11.81,3-21.89,3.21-24.52.5a2.19,2.19,0,0,1-.54-2.29,7.17,7.17,0,0,1,1.83-2.82c4.43-4.63,15.92-10.11,28.55-13.33,11.79-3,21.88-3.2,24.5-.49a2.18,2.18,0,0,1,.54,2.29c-1.2,4.25-11.23,10.12-23.64,14.18a3.55,3.55,0,0,1-.56.73c10.23-3.27,19-7.82,22.79-11.81a7.5,7.5,0,0,0,1.91-3,2.7,2.7,0,0,0-.66-2.8C397.18,111.65,387.13,111.79,375,114.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.81,126.9a2.11,2.11,0,1,1-3,.06A2.12,2.12,0,0,1,347.81,126.9Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.81,126.9a2.11,2.11,0,1,1-3,.06A2.12,2.12,0,0,1,347.81,126.9Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.73,129.77a2,2,0,0,1-2.49-1.29,2.11,2.11,0,1,0,4.06-.86A2.19,2.19,0,0,1,346.73,129.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.12,98.19a2.11,2.11,0,1,1-3,.07A2.12,2.12,0,0,1,375.12,98.19Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.12,98.19a2.11,2.11,0,1,1-3,.07A2.12,2.12,0,0,1,375.12,98.19Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,101.07a2.07,2.07,0,0,1-2.5-1.3,2.16,2.16,0,0,0,.65,1.47,2.11,2.11,0,0,0,3.42-2.33A2.2,2.2,0,0,1,374,101.07Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.49,137.76a2.11,2.11,0,1,1-3,.06A2.12,2.12,0,0,1,389.49,137.76Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.49,137.76a2.11,2.11,0,1,1-3,.06A2.12,2.12,0,0,1,389.49,137.76Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.41,140.63a2,2,0,0,1-2.49-1.29,2.08,2.08,0,0,0,.65,1.47,2.11,2.11,0,0,0,3.41-2.33A2.19,2.19,0,0,1,388.41,140.63Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--molecules--inject-97",
    d: "M332,168a2.29,2.29,0,0,0-1.82-2.68,2.21,2.21,0,0,0-.85,0l-1.54-3.69a2.31,2.31,0,0,0,.94-1.45,2.27,2.27,0,0,0-.06-1.07l4-2.19a2.31,2.31,0,0,0,1.3.75,2.31,2.31,0,1,0-1.76-1.6l-4,2.19a2.28,2.28,0,0,0-3.32-.16L317.35,153a3.34,3.34,0,0,0,.29-.84,3.43,3.43,0,0,0-.4-2.37l5.16-4a2.28,2.28,0,1,0-.79-2.18,2.36,2.36,0,0,0,.19,1.42l-5.15,4a3.45,3.45,0,0,0-1.73-.91l.67-11.62a2.29,2.29,0,1,0-2.61-2.69l-6.39.14a2.29,2.29,0,1,0,0,1l6.4-.15a2.29,2.29,0,0,0,1.61,1.67L314,148a3.46,3.46,0,0,0-.36,6.84,2.92,2.92,0,0,0,.5.05l.64,6.51a2.29,2.29,0,1,0,2.95,2.61,2.3,2.3,0,0,0-1.82-2.69h-.17l-.63-6.51a3.44,3.44,0,0,0,1.75-1.05l7.58,5.07a1.77,1.77,0,0,0-.12.41,2.29,2.29,0,0,0,1.81,2.68,2.21,2.21,0,0,0,.85,0l1.55,3.69a2.31,2.31,0,0,0-.94,1.45,2.29,2.29,0,1,0,4.5.86Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.92,337.72l-9.33-77.84-7.62-.39,13.11,78.22h0a1,1,0,0,0,.51.68,3,3,0,0,0,2.72.14.91.91,0,0,0,.59-.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.59,259.88l-7.62-.39,2.46,14.68a14.17,14.17,0,0,0,4.21-1.69,5.74,5.74,0,0,0,2.21-2.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,251.82h-7.63l-11.1,73.5h0a.94.94,0,0,0,.56.84,3,3,0,0,0,2.72,0,1,1,0,0,0,.54-.66h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.34,251.82l-3.1,20.51a30.21,30.21,0,0,0,5.86,3.58L133,251.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.6,367.16,185.42,288l-7.62-.39,11,79.52h0a1,1,0,0,0,.5.69A3,3,0,0,0,192,368a.92.92,0,0,0,.6-.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.46,299.4l-1-11.38-7.62-.39,1.69,12.28C181.19,300.43,184.24,300.12,186.46,299.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,224.24h-7.63l-11.11,73.51h0a.91.91,0,0,0,.55.83,3,3,0,0,0,2.72,0,1,1,0,0,0,.55-.65h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chair--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.15,162.81a43.13,43.13,0,0,0-3.05,13.4c-.87,10.27,2.46,48.24,4.55,63.11h0c3,24.85,6.72,24.9,12.11,29.06,9.26,7.15,35.9,21.18,44.7,24.64,15.94,6.28,29-3.4,38.7-8.2s28-15.63,32.07-18.6c2.43-1.77,3.69-3.55,3.66-5.43,0-.75,0-3.8,0-4.59,0-2.4-2.12-5-6.58-7.86-8.23-5.35-38-22.7-49.53-29.09a.12.12,0,0,0-.1-.1c-8.87-5.38-14.06-46.71-20.21-66.19-.13-.42-.26-.82-.4-1.21s-.21-.62-.32-.91c-.38-1.06-.78-2-1.2-2.92",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.89,256.19c0-2.4-2.12-5-6.58-7.86-8.23-5.35-38-22.7-49.53-29.09a.12.12,0,0,0-.1-.1c-8.87-5.38-14.06-46.71-20.21-66.19a36.59,36.59,0,0,0-1.29-3.59c0-.09-.07-.17-.11-.26-.11-.26-.22-.52-.35-.79s-.11-.27-.17-.4h0a18.82,18.82,0,0,0-4.1-5.92,8.91,8.91,0,0,0-2-1.41c-1-.57-3.1-1.73-3.62-2-6-3.61-20.27,4.08-30.12,9.47-6.13,3.36-11.35,7.36-14.54,14.8h0a43.13,43.13,0,0,0-3.05,13.4c-.87,10.27,2.46,48.24,4.55,63.11h0c3,24.85,6.72,24.9,12.11,29.06,9.26,7.15,35.9,21.18,44.7,24.64,15.94,6.28,29-3.4,38.7-8.2s28-15.63,32.07-18.6c2.43-1.77,3.69-3.55,3.66-5.43C243.87,260,243.89,257,243.89,256.19Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.89,256.19c0-2.4-2.12-5-6.58-7.86-8.23-5.35-38-22.7-49.53-29.09a.12.12,0,0,0-.1-.1c-8.87-5.38-14.06-46.71-20.21-66.19a36.59,36.59,0,0,0-1.29-3.59c0-.09-.07-.17-.11-.26-.11-.26-.22-.52-.35-.79s-.11-.27-.17-.4h0a18.82,18.82,0,0,0-4.1-5.92,8.91,8.91,0,0,0-2-1.41c-1-.57-3.1-1.73-3.62-2-6-3.61-20.27,4.08-30.12,9.47-6.13,3.36-11.35,7.36-14.54,14.8h0a43.13,43.13,0,0,0-3.05,13.4c-.87,10.27,2.46,48.24,4.55,63.11h0c3,24.85,6.72,24.9,12.11,29.06,9.26,7.15,35.9,21.18,44.7,24.64,15.94,6.28,29-3.4,38.7-8.2s28-15.63,32.07-18.6c2.43-1.77,3.69-3.55,3.66-5.43C243.87,260,243.89,257,243.89,256.19Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.14,280.19c9.72-4.79,28-15.63,32.08-18.6,5.52-4,5-8.12-2.91-13.26-11-7.14-55.86-32.6-55.86-32.6s-63,36.83-60.61,43,37.55,25.3,48.61,29.65C185.4,294.66,198.43,285,208.14,280.19Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.43,140.58c-6-3.14-20.06,4.48-29.66,9.74-6.15,3.37-11.38,7.36-14.57,14.83l-4-2.34c3.18-7.44,8.41-11.44,14.54-14.8,9.85-5.39,24.09-13.08,30.12-9.47C156.33,138.85,158.43,140,159.43,140.58Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.47,153c-.13-.42-2.18-7.57-6-11a9.74,9.74,0,0,0-6.53-2.49c-5.21,0-17.8,6.8-25.14,10.82-.61.33-1.22.68-1.81,1l-.68.41c-.28.16-.55.34-.81.51s-.4.25-.6.39a32.54,32.54,0,0,0-3.69,2.8c-.19.17-.38.33-.56.51a25.57,25.57,0,0,0-2.1,2.18c-.12.13-.24.27-.35.41l-.41.52c-.14.17-.27.35-.41.53l-.39.55a26,26,0,0,0-1.47,2.35,3.07,3.07,0,0,0-.17.31c-.12.21-.23.44-.34.66s-.32.66-.48,1a42.35,42.35,0,0,0-3.32,14c-1.43,16.88,4.21,77.35,10,82.16,0,0-.89-5.46,10.78-12.8,7.93-5,13.5-9.19,22-13.34,20.63-10.13,32.74-15.39,32.74-15.39C178.81,213.76,173.62,172.43,167.47,153Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.47,153c-.13-.42-2.18-7.57-6-11a9.74,9.74,0,0,0-6.53-2.49c-5.21,0-17.8,6.8-25.14,10.82-.61.33-1.22.68-1.81,1l-.68.41c-.28.16-.55.34-.81.51s-.4.25-.6.39a32.54,32.54,0,0,0-3.69,2.8c-.19.17-.38.33-.56.51a25.57,25.57,0,0,0-2.1,2.18c-.12.13-.24.27-.35.41l-.41.52c-.14.17-.27.35-.41.53l-.39.55a26,26,0,0,0-1.47,2.35,3.07,3.07,0,0,0-.17.31c-.12.21-.23.44-.34.66s-.32.66-.48,1a42.35,42.35,0,0,0-3.32,14c-1.43,16.88,4.21,77.35,10,82.16,0,0-.89-5.46,10.78-12.8,7.93-5,13.5-9.19,22-13.34,20.63-10.13,32.74-15.39,32.74-15.39C178.81,213.76,173.62,172.43,167.47,153Z",
    style: {
      opacity: 0.15
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.76,299.71c-5.42-.3-9.68,4.36-10,5.77-.45,1.9.05,5.65,2.61,10.11A32.32,32.32,0,0,1,207.88,330c0,4.28-1.23,15,3.47,20s14.58,8.86,17.38,1.31c.92-2.47-2-10.56-3.43-16.51-2.93-11.85-5.4-23.66-5.4-23.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.37,303.22c.06,4,3.2,13.24,9.27,21.64,6,8.24,14.3,18.91,16.26,25-.08-2.85-1.69-7.95-2.94-12.51,0-.1-.05-.2-.08-.29l-.21-.79c0-.12-.07-.24-.1-.36-.09-.34-.17-.67-.25-1l0-.07c-.91-3.7-1.79-7.4-2.55-10.74-.61-2.67-1.15-5.1-1.6-7.12l-.59-2.7c-.08-.39-.16-.74-.23-1.07-.27-1.29-.43-2-.43-2l-8.14-11.44c-.36,0-.7,0-1,0A11.81,11.81,0,0,0,203.37,303.22Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.84,309.42a118,118,0,0,1,2.76,17.51c.4,6.45,2.1,10.58,4.55,13.28,2.71,3,9,4.26,7.73-2.32-.87-4.57-6-26.74-6-26.74Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.91,342.15c.92-.65,1.41-2,1-4.26-.2-1-.61-3-1.13-5.34-.71-2.93-1.39-5.82-2-8.48s-1.15-5.1-1.6-7.12l-.59-2.7c-.08-.39-.16-.74-.23-1.07-.27-1.26-.42-2-.43-2h0l-9.06-1.73a120.69,120.69,0,0,1,2.7,16.68C217.26,331.21,221.69,337.07,224.91,342.15Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.01 287.24 230.22 312.24 213.83 298.21 220.66 269.3 241.01 287.24",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.22,224.25a318.88,318.88,0,0,0-31.06-11.39L175,232.24l20.15,14,27,12.87s-1.43,3.09-3.06,11.49c-.45,2.33-.87,3.95-1.21,6.14,7.6,8,11.64,20.43,18.51,22.37,0,0,9.73-20,16.08-36.26,6-15.29,1.82-20.48.46-22.51C250.56,236.82,244.47,232.12,226.22,224.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.48,286.18c0-.23-.1-.45-.14-.67-.41-2-.82-3.91-1.19-5.67a.85.85,0,0,1,0-.17l-.54-2.46a.64.64,0,0,1,0-.07h0c-.44-2-.84-3.66-1.15-4.83-1-3.85-4.26-8.58-6.74-11.8a71.6,71.6,0,0,0-2.26,8.76c0,.07,0,.15.06.21l4.92,13.13h0l2.56,6.84.77,1.18.21.33q1.08,1.64,2.16,3.06l.26.33c.22.27.43.53.65.78s.19.23.29.35.44.49.66.72l.25.24a13.38,13.38,0,0,0,1.6,1.37h0c-.67-3.49-1.4-7.15-2.11-10.64h0C231.61,286.84,231.54,286.51,231.48,286.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.6,257.92c-1.71-1.65-5.39-5.16-7.15-6.63-6.61-5.57-21-16.95-21-16.95l-3.45.87,7.17,11.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.81,358c-1.32,0-1.22,2.26-1.78,5.15a14.52,14.52,0,0,0,.28,8.51c1.36,3.5,7.07,3.76,10.24,8.29s7.84,12.73,18.07,14.76,18-1.43,19.83-4.49.12-5.92-6.45-9.57c-7-3.87-9-5-9-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.6,326.12q1.36,2.33,3,4.84c4.56,8.13,10,17.93,11.59,22.52.81,2.29.71,3.31.75,6a6.56,6.56,0,0,0,1.86,4.1,49.27,49.27,0,0,0,3.57,3.51c3.32,3,8.62,11.12,14.11,14.75s14.86,2.57,16.95.32a2,2,0,0,0,0-3c-1-1-3.56-3.15-4.71-4.34a81.93,81.93,0,0,1-13.21-17.55c-1.82-3.32-4.74-12.42-7.55-22h0s-1.85-7.23-4.4-17",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.53,268.32c-3.53-8.65-38.41-35.24-38.41-35.24s3.69-14.88,5.72-25.21l-57.06,8.19c-2,7.23-3,17.36.21,25,4.23,10.11,15.71,18.44,30.22,26.49,13.57,7.53,28.36,14.69,31.8,16.48,3,1.57,4.15,4,4.94,10.47.75,6.19,4.39,14.24,14.65,31.64,6.87,1.4,18.86-3.55,21.94-7.86C232.86,300.34,225.81,273.92,223.53,268.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.67,224.74A17.94,17.94,0,0,1,188,235.21l1.93,1.61S195.59,233.22,195.67,224.74Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.05,136.14c11.27,0,18.39,4,27.25,21.4,6.22,12.23,18.39,42.52,18.39,42.52l-16.44,7.56C197,196.3,189.81,182.22,181.12,163Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.52,179.37c6.42-10.08,3.72-17.35,1.52-21.58-4.42-8.47-19-21.65-19-21.65s-3.27-.57-16.46.33a94.53,94.53,0,0,0-21.61,4c2.76,9.38,5.82,13.09,5.16,18.45s-6.67,15.54-6.67,15.54l2.67,9.68s1.61,6.82,2.42,10c.56,2.17-.8,7-2,9.76a75.86,75.86,0,0,0-6.17,21.43c23.34,8.75,54.3,2.86,64.64-12.53-.68-3.89-4.73-11.78-5.07-16S191,186.8,191.52,179.37Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.22,181s-4.94,6.17-15.57,4.39-12.73-9.8-12.73-9.8S146.29,185.88,159,188C171.51,190,175.22,181,175.22,181Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.69,126.25c2.88,9,21.39-9.35,24.33-12.42,1.23-1.29,2-3.35,3.11-4.79a28.59,28.59,0,0,1,2.9-3.22c1.77-1.6,4.24-2.06,6.06-3.71a14.3,14.3,0,0,0,3.72-5.42A15.81,15.81,0,0,0,187.28,84a19.35,19.35,0,0,0-4.16-5.33,31.23,31.23,0,0,0-15.92-8c-9.86-1.73-21.35,1.12-28.12,8.49-6,6.51-8,14.84-7,21C134.48,115.4,146.11,121.29,147.69,126.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.58,81.39c3.35,2,7.52,10.36,7.14,28-.28,13.1-4.5,17.57-6.92,18.64a20.64,20.64,0,0,1-11.05.9v7.88s9.47,6.77,7.46,11.06c-1.75,3.74-11.88,4-17.79,0a42.2,42.2,0,0,1-9.7-9.39l-.06-21.54s-2.81,2.43-6.15-.8c-2.4-2.32-4-8.26-2.49-11.38a5.41,5.41,0,0,1,8.77-1.46s5.57.45,15.89-5.6C172.18,92.71,177.27,86.12,178.58,81.39Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.75,128.92c-4.81-.62-15.41-4.45-17-8.36a8.28,8.28,0,0,0,3,5.35c4.09,3.65,14,6,14,6Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.42,77.22c3.83,5.26,3.55,18.87-10.28,22A10,10,0,0,0,172.33,93s-4.15,6.8-20.16,9.14l.93-25.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.81,111.15h0l0-7.86,5-2.37v5.2A5,5,0,0,1,147.81,111.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,102.57a2,2,0,1,1-3.74,1.48,1.68,1.68,0,0,1,1.08-2.34A1.93,1.93,0,0,1,167,102.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.06,103.36a2,2,0,0,1-2.62,1.23,2.07,2.07,0,0,1-1.13-2.68,1.77,1.77,0,0,1,2.51-.84C181.85,101.47,182.48,102.28,182.06,103.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,98.62l-4-2.32a2.23,2.23,0,0,1,3.1-.9A2.44,2.44,0,0,1,183,98.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.91,116.1l6.05,1.38a3,3,0,0,1-3.61,2.39A3.25,3.25,0,0,1,166.91,116.1Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.76,117.15a3.35,3.35,0,0,0-.85.12,3.25,3.25,0,0,0,2.44,2.6,3,3,0,0,0,1.71-.12A3.4,3.4,0,0,0,167.76,117.15Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.13,112.28a6,6,0,0,1-6-5.64,3.09,3.09,0,0,1,.62-2.35c.91-1,2.63-1.13,4.63-1.26l1.1-.07c2-.14,3.72-.26,4.76.65a3.07,3.07,0,0,1,.93,2.24,6.05,6.05,0,0,1-5.63,6.42Zm2.34-8.83c-.6,0-1.26,0-2,.1l-1.11.07c-1.86.11-3.47.21-4.22,1.06a2.53,2.53,0,0,0-.48,1.92,5.45,5.45,0,0,0,10.87-.71,2.53,2.53,0,0,0-.73-1.84A3.56,3.56,0,0,0,167.47,103.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.52,112.28a6,6,0,0,1-6-5.64,3.09,3.09,0,0,1,.63-2.35c.91-1,2.63-1.13,4.62-1.26l1.11-.07c2-.14,3.71-.26,4.75.65a3.07,3.07,0,0,1,.93,2.24,6,6,0,0,1-5.62,6.42Zm2.34-8.83c-.6,0-1.26,0-2,.1l-1.11.07c-1.87.11-3.47.21-4.22,1.06a2.53,2.53,0,0,0-.48,1.92,5.44,5.44,0,0,0,5.79,5.08,5.47,5.47,0,0,0,5.08-5.79,2.57,2.57,0,0,0-.73-1.84A3.59,3.59,0,0,0,183.86,103.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.85 101.34 172.67 114.35 178.94 112.28 171.85 101.34",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.05,107.43l-.56-.18a4.06,4.06,0,0,1,3.29-3.06,2.29,2.29,0,0,1,2.33,1.27l-.52.27a1.78,1.78,0,0,0-1.76-1A3.46,3.46,0,0,0,171.05,107.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.49,
    y: 98.71,
    width: 0.59,
    height: 11.55,
    transform: "translate(21.76 235.4) rotate(-78.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.47,174.41s-.2-1.85,2.18-3.76,5.54-3.49,6.41-8l3.45,1.82-5.32,9.8Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.47,174.41s-.2-1.85,2.18-3.76,5.54-3.49,6.41-8l3.45,1.82-5.32,9.8Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.47,174.41s-3.77-1.7-11.8.28-14.56,4.41-30.13,4.68l4.13,2.17L223,177.62Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.47,174.41s-3.77-1.7-11.8.28-14.56,4.41-30.13,4.68l4.13,2.17L223,177.62Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.54 179.37 165.92 226.39 170.04 228.56 182.67 181.54 178.54 179.37",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.54 179.37 165.92 226.39 170.04 228.56 182.67 181.54 178.54 179.37",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.54 179.37 165.92 226.39 170.04 228.56 182.67 181.54 178.54 179.37",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M229.15,165.1a8.25,8.25,0,0,1-1.56,2.69,24.28,24.28,0,0,1-2.24,2.18,15.91,15.91,0,0,0-2.19,2.15,5.78,5.78,0,0,0-.75,1.29,3.05,3.05,0,0,0-.24,1.39l-.49.09a3.44,3.44,0,0,1,.33-1.65,6,6,0,0,1,.86-1.35,15.86,15.86,0,0,1,2.32-2.11,22.72,22.72,0,0,0,2.3-2.08A8.07,8.07,0,0,0,229.15,165.1Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M228.6,167.75a7.59,7.59,0,0,1-1.18,1.64c-.44.51-.9,1-1.33,1.51a10.19,10.19,0,0,0-1.16,1.62,4.17,4.17,0,0,0-.57,1.81l-.49,0a4.49,4.49,0,0,1,.74-2,10,10,0,0,1,1.29-1.59c.47-.49,1-1,1.43-1.43A7.61,7.61,0,0,0,228.6,167.75Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M194.11,179.1a58,58,0,0,0,6.54-1.23c2.16-.52,4.29-1.14,6.44-1.73a31.22,31.22,0,0,1,6.59-1.12,23.55,23.55,0,0,1,3.36,0,12.17,12.17,0,0,1,1.68.25,4.28,4.28,0,0,1,1.62.73l-.33.37a3.6,3.6,0,0,0-1.4-.64,9.5,9.5,0,0,0-1.61-.27,22.7,22.7,0,0,0-3.3-.07,30.87,30.87,0,0,0-6.55,1c-2.15.55-4.3,1.14-6.47,1.62A60.84,60.84,0,0,1,194.11,179.1Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M204.78,178.48c1.24-.21,2.47-.52,3.7-.81s2.47-.56,3.72-.78a25.1,25.1,0,0,1,3.79-.4,10.59,10.59,0,0,1,3.81.56l-.18.46a10.09,10.09,0,0,0-3.63-.64,25,25,0,0,0-3.76.27c-1.24.18-2.49.41-3.73.66S206,178.31,204.78,178.48Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "232.43 162.1 226.22 173.72 212.68 224.13 214.74 225.22 220.84 211.05 234.49 163.19 232.43 162.1",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.28 174.8 234.49 163.19 220.84 211.05 214.74 225.22 228.28 174.8",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.73 177.81 180.01 181.91 166.47 232.33 168.53 233.42 208.25 229.31 221.79 178.89 219.73 177.81",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.07 183 168.53 233.42 208.25 229.31 221.79 178.89 182.07 183",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.01 181.91 182.07 183 168.53 233.42 166.47 232.33 180.01 181.91",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.79,178.89l6.49-4.09-13.54,50.42c-.93,2.73-3.16,4-6.49,4.09Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.79,178.89l6.49-4.09-13.54,50.42c-1.05,2.89-3.35,4.06-6.49,4.09Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,173.59c-1.26-.67-3.73-.31-5.52.82s-2.22,2.59-1,3.26l2.28,1.22,6.49-4.09-2.06-1.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.22,173.71c-.32,1.93-2.72,3.22-6.49,4.1l2.06,1.08c3.25-.5,5.37-1.91,6.49-4.09Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.63,140.27c-9.81,2.36-13,4.93-15.52,16.52-2.67,12.28-6,34.59-6.4,49.3-.13,4.88-.76,8.18,11.07,11.69,13.78,4.08,32.06,5.82,37.17,6.25,3.27.27,10.47.9,13,.6,8-1,12.2-5.7,14.69-8.18,1.38-1.36,2.73-3,2.7-5a6.81,6.81,0,0,1,0-1.86,8.92,8.92,0,0,1,.89-1.63,3.22,3.22,0,0,0,.32-2,10.62,10.62,0,0,1-.35-1.82c0-1.25,1.17-2.16,1.68-3.3a1,1,0,0,0,.12-.54c0-.42-.49-.66-.89-.75a8.23,8.23,0,0,0-5.39,1.21c-5,3.07-7.9,6.88-15,7.09-1.68,0-3.72-.63-3.28-2.26l.86-3.22c-4,.82-6.2,4.79-9.52,5.48-3,.61-26.85-7.37-26.85-7.37l6.33-27.18S146.33,148,136.63,140.27Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.55,191a27.4,27.4,0,0,1-2.62,5.12c-.75,1.32-.64,2.85.24,3.23l-2.38,8.34s1.18.13,3.6-2.7,4.09-8.12,4.55-11,.8-8-1.63-9.19Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.17,110.92c-4.14,3.87-6.79,12.39-1,18.77a8.53,8.53,0,0,0-1.67,8,11.48,11.48,0,0,0,4.42,6,8,8,0,0,0,.18,7.63,11.87,11.87,0,0,0,6.23,5s-1.24,2.75,1.56,6.36c2.62,3.37,7.19,3.6,7.19,3.6s-1,2.76,1.66,6c2.42,3,6.82,3.41,6.82,3.41a6.48,6.48,0,0,0,.68,6.37,5.62,5.62,0,0,1,.34,6.35A11.43,11.43,0,0,0,169,178.37c.31-5-3.33-5.75-3.33-5.75s.29-4.94-1.65-7.38c-2.22-2.8-4-2.58-4-2.58a12.55,12.55,0,0,0-1.81-7.24c-2.11-3-4.5-2.8-4.5-2.8s1.22-3.9.45-6.91c-.93-3.62-3.15-4.42-3.15-4.42a8.79,8.79,0,0,0-2.77-10.24,7.84,7.84,0,0,0,.43-3.67c-.19-3-.74-2.52-1-6.38C141,117.91,140.13,115.45,136.17,110.92Z",
    style: {
      fill: "#263238"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Globe--inject-97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--globe--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.35,389.19a4.65,4.65,0,0,1-.34-.56l-.08-.15c-.08-.17-.15-.33-.21-.49s0-.11,0-.16a4.71,4.71,0,0,1-.16-.62v0a3.35,3.35,0,0,1-.05-.63v-.19c0-.15,0-.3,0-.45a1.85,1.85,0,0,1,0-.23,3.2,3.2,0,0,1,.1-.42,1.72,1.72,0,0,1,.07-.21,5.09,5.09,0,0,1,.25-.6l.1-.18c.08-.14.16-.28.25-.42l.18-.24.13-.18.21-.25.12-.13a14.71,14.71,0,0,1,22.18,0l.09.11.22.26a1.15,1.15,0,0,1,.14.19,2,2,0,0,1,.17.23,4,4,0,0,1,.27.44l.09.16a5.09,5.09,0,0,1,.25.6l.06.19c0,.15.08.3.11.45a1.55,1.55,0,0,1,0,.21c0,.16,0,.32,0,.47v.17a4.46,4.46,0,0,1-.21,1.29.69.69,0,0,0-.05.13,4.77,4.77,0,0,1-.22.52.83.83,0,0,1-.07.13,5.08,5.08,0,0,1-.35.59l0,0a7,7,0,0,1-.51.63l0,0a6.78,6.78,0,0,1-.54.53l-.14.12-.57.45-.15.11c-.26.18-.52.35-.81.52-4.91,2.84-12.88,2.84-17.79,0-.29-.17-.55-.34-.81-.52l-.16-.12a6.17,6.17,0,0,1-.55-.43l-.16-.13a6.38,6.38,0,0,1-.52-.52l-.06-.06a7.14,7.14,0,0,1-.5-.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,367.36a1.93,1.93,0,0,1,1,.23.7.7,0,0,1,.39.49h0c.25,5.76.7,8.55,2.54,11.61a1.93,1.93,0,0,1-1.14,1.59,5.63,5.63,0,0,1-2.76.66h0a5.62,5.62,0,0,1-2.75-.66,1.93,1.93,0,0,1-1.14-1.59c1.84-3.06,2.29-5.85,2.53-11.61h0a.67.67,0,0,1,.39-.49A1.9,1.9,0,0,1,85,367.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83.65,368.67c.92,0,1.85,0,2.77,0,.08,1.81.19,3.57.36,5.23-1.16,0-2.31-.09-3.47-.2C83.47,372.09,83.57,370.4,83.65,368.67Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.07,389.92c4.08-2.56,3.79-7.13,1.08-9.46a14.85,14.85,0,0,1,3,2.61l.09.11.22.26a1.15,1.15,0,0,1,.14.19,2,2,0,0,1,.17.23,4,4,0,0,1,.27.44l.09.16a5.09,5.09,0,0,1,.25.6l.06.19c0,.15.08.3.11.45a1.55,1.55,0,0,1,0,.21c0,.16,0,.32,0,.47v.17a4.46,4.46,0,0,1-.21,1.29.69.69,0,0,0-.05.13,4.77,4.77,0,0,1-.22.52.83.83,0,0,1-.07.13,5.08,5.08,0,0,1-.35.59l0,0a7,7,0,0,1-.51.63l0,0a6.78,6.78,0,0,1-.54.53l-.14.12-.57.45-.15.11c-.26.18-.52.35-.81.52-4.91,2.84-12.88,2.84-17.79,0-.29-.17-.55-.34-.81-.52l-.16-.12a6.17,6.17,0,0,1-.55-.43l-.16-.13a6.38,6.38,0,0,1-.52-.52l-.06-.06C79,393.49,88,392.48,92.07,389.92Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M113.29,352.87a39.91,39.91,0,0,1-56.44-56.44l-2.58-2.57c-17.94,17.95-19.65,45.34-1.7,63.29s45.32,16.22,63.27-1.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.53,296.83l2.6,2.6c.85-1,1.75-2,2.72-3l-2.58-2.57C53.31,294.82,52.4,295.82,51.53,296.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.29,352.87c-1,1-2,1.86-3,2.7l2.58,2.58c1-.86,2-1.77,3-2.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.61,328.57C42.76,338,46.16,349,55.3,357c7.79,6.84,19.71,14.1,38.05,11.42a42.11,42.11,0,0,1-40.78-11.26c-17.41-17.41-16.33-43.72.15-61.66C52,296.3,39.53,311.55,41.61,328.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.26,359.09a2.26,2.26,0,0,0,1.6-3.86L54.47,290.88a2.26,2.26,0,0,0-3.2,3.2l64.39,64.35A2.26,2.26,0,0,0,117.26,359.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.47,290.88l64.39,64.35a2.25,2.25,0,0,1,.52,2.39,2.26,2.26,0,0,1-2.29-.55l-64.4-64.35a2.27,2.27,0,0,1-.51-2.39A2.26,2.26,0,0,1,54.47,290.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.83,356.82A37,37,0,1,0,48.26,328,37,37,0,0,0,66.83,356.82Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.83,356.82A37,37,0,1,0,48.26,328,37,37,0,0,0,66.83,356.82Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,302.74c-1.3,1.08-2.63,2.9-.8,2.67s2.67-.79,3.46.18,1,2.5,1.83,2.94,2,.84,2.34.2.47-3.27,1.31-3.82,3.61-2.58,3.3-3.76.14-1.44,0-2.92-1.2-2.76-2-2.14-.62,1-2,2-2.67.57-3.77,1.81A25.46,25.46,0,0,1,62,302.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.31,307c-.86,2-3.05,5.73-4.84,6.49a32.18,32.18,0,0,0-3,1.34,37.09,37.09,0,0,0,2.3,25.81,12.25,12.25,0,0,0,2.92,1c2.22.43,3.54-.34,5.21-1.22s1.87.3,3.26.59a8,8,0,0,0,3.28.34c1.18-.19.77,1.56,1.2,2.75s.75,1.79,2.93,3.15,5.36,1.37,6.52,1.65.87,1.9,2.35,3.25,4.67,5.5,8,6.62,4,.14,2.63-1.31-3-2.53-3.06-4.41,2-3,1-5.65-.6-2.84-.19-4.35-.53-1.78-.93-4.16-1.36-4.14-3.26-3.74-2.74,1.2-5.18.52a19,19,0,0,0-7.9-.34c-2.41.43-4.19,3.67-5.5,4.21s-3.61-.95-4.17-1.79-1.51-.41-2.12.4-1.43.65-2.46-.21-.47-3.42.75-4.55,2.39-1.09,4,.37a4.15,4.15,0,0,0,4.78.76c1.44-.65-.3-1.3-1.83-1.47s-2.19-.9-3-3.28.83-3.49.63-6.15,1.05-1.54,2.37-2.31.64-1.27.22-2.7,1.82-1.69,2.35-3.56-3.12-1.16-3.9-2.48.43-2.21-1.64-3.46-1.22-2-1.27-3.08S58.17,305,57.31,307Zm1.7,5.72c.31,1.19-.16,1.29,0,2.76a4.58,4.58,0,0,1-1,3.39c-.58.6-2.56.3-3.18-.37s.23-1.7,1.27-2.77a8.32,8.32,0,0,0,2-4C58.36,310.38,58.7,311.55,59,312.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.17,299.45l.07.08a2.66,2.66,0,0,0-.24,2.05c.63,2.13,0,1.53-.72,3.85s.61,2.72,1.57,3.75.16,3.71-.41,4.8,1,3.91,2.3,4.9.19,2.64.19,4.46,1,4.09,1.1,5.45a3.51,3.51,0,0,1-1.71,3.4c-1.2.66-3.57-.31-5.35-1.37a11.23,11.23,0,0,1-4.3-4.5c-1-1.91-.94-1.61-3.39-3.87a5.26,5.26,0,0,0-6.07-1c-1.19.55-2.37,2.44-3.67,2.63s-2.28-.26-4.79-2.22-1.76-3.47-1.86-5.53a11.53,11.53,0,0,1,1.94-6.68,6.27,6.27,0,0,1,4.2-2.55c1.42-.3,2.8.45,3.58-.05s1.11-1.37,1.94-1.81,1.61-.47,2.21-1.15-.48-1.14-.94-1.51-1,.26-1.86.93a1.57,1.57,0,0,1-2,.29c-.75-.32-.84.56-1.43.65s.32,1.07.6,1.5-.59,0-.59,0,.09.82-.26.69-.49-1-1-1.59-1.32.28-2.26.24a2.75,2.75,0,0,0-2.34,1.39c-.56.86-.85.79-.65,1.73s-1.09,2.73-1.69,3.06-1.08-1-1.38-2.34.88-1.73.69-3.15-1.08-.91-1.73-.64-1.23-.11-1.65-1.76.6-1.92,1.35-1.6A2.39,2.39,0,0,0,84,301.4c.72-.55.15-.93-.69-1.95a2.47,2.47,0,0,1-.19-3.12,17,17,0,0,0,1.85-4.1c.15-1.06,1.52-1.54,2.57-1.38s2.49-.61,4-1.45a1.38,1.38,0,0,0,.69-1A36.79,36.79,0,0,1,112.17,299.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.11,318c-.8.44-.55.62-.52,1.51s-.07,2,.5,2.48,1.19,1.16,1.34.34-.43-1.19,0-2.05S119.31,317.34,118.11,318Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.18,293c-22.65,9.38-16.08,24.67,0,24.8s34.87-10.62,33-17.64S89,286.05,72.18,293Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.82,345.39c-23.68-.32-41.43-23.47-34.76-40.85h0c-.39.6-.77,1.21-1.13,1.84a37,37,0,1,0,67.74,8.15C121.11,323.37,112.48,345.72,88.82,345.39Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-97"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "240.44 364.66 240.44 479.1 237.06 477.15 237.06 362.7 240.44 364.66",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.44 364.66 240.44 479.1 243.82 477.15 243.82 362.7 240.44 364.66",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.09 304.41 136.09 418.85 132.7 416.9 132.7 302.45 136.09 304.41",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.09 304.41 136.09 418.85 139.47 416.9 139.47 302.45 136.09 304.41",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.61 260.59 420.61 375.03 417.23 373.08 417.23 258.63 420.61 260.59",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.61 260.59 420.61 375.03 423.99 373.08 423.99 258.63 420.61 260.59",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.44 346.58 240.44 370.68 132.7 308.48 132.7 284.38 240.44 346.58",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.44 370.68 423.99 264.66 424 252.61 240.44 358.63 240.44 370.68",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-97"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "240.44 358.63 122.27 290.41 316.25 178.36 434.43 246.59 240.44 358.63",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.44 358.63 122.27 290.41 316.25 178.36 434.43 246.59 240.44 358.63",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.27 290.41 122.27 296.43 240.44 364.66 240.44 358.63 122.27 290.41",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.27 290.41 122.27 296.43 240.44 364.66 240.44 358.63 122.27 290.41",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.44 364.66 434.43 252.61 434.43 246.59 240.44 358.63 240.44 364.66",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.44 364.66 434.43 252.61 434.43 246.59 240.44 358.63 240.44 364.66",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lamp--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-97",
    d: "M415.33,240.69c7,3.87,7,10.14,0,14s-18.31,3.87-25.3,0-7-10.14,0-14S408.35,236.82,415.33,240.69Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.32,245.92a5,5,0,0,0-.11-1.16,17.46,17.46,0,0,0-7.11-10.6H395.26a17.42,17.42,0,0,0-7.1,10.59,4.65,4.65,0,0,0-.12,1.17,1.8,1.8,0,0,0,0,.2c.14,2,1.55,4.08,4.26,5.65,5.72,3.31,15,3.31,20.72,0,2.72-1.56,4.13-3.6,4.27-5.65C417.31,246.12,417.32,246,417.32,245.92Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M417.32,245.92a5,5,0,0,0-.11-1.16,17.46,17.46,0,0,0-7.11-10.6H395.26a17.42,17.42,0,0,0-7.1,10.59,4.65,4.65,0,0,0-.12,1.17,1.8,1.8,0,0,0,0,.2c.14,2,1.55,4.08,4.26,5.65,5.72,3.31,15,3.31,20.72,0,2.72-1.56,4.13-3.6,4.27-5.65C417.31,246.12,417.32,246,417.32,245.92Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M395.64,233.93c-3.89,2.24-3.89,5.88,0,8.13a15.59,15.59,0,0,0,14.08,0c3.89-2.25,3.89-5.89,0-8.13A15.53,15.53,0,0,0,395.64,233.93Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.06,238.21a3,3,0,0,0,.44-.59L420,205.47l-4.56-2.39-15.29,33.65h0c-.41.85-.42,1.4.48,1.92a4.3,4.3,0,0,0,3.92,0,1.74,1.74,0,0,0,.46-.37h0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.06,238.21a3,3,0,0,0,.44-.59L420,205.47l-4.56-2.39-15.29,33.65h0c-.41.85-.42,1.4.48,1.92a4.3,4.3,0,0,0,3.92,0,1.74,1.74,0,0,0,.46-.37h0Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.18,196.77h0a2.29,2.29,0,0,0-2.31.81,7.38,7.38,0,0,0-1.69,6.45,2.43,2.43,0,0,0,1.32,1.74v0l5.09,1.9,2.54-9.07Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M417.18,196.77h0a2.29,2.29,0,0,0-2.31.81,7.38,7.38,0,0,0-1.69,6.45,2.43,2.43,0,0,0,1.32,1.74v0l5.09,1.9,2.54-9.07Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M419.89,199.47a7.36,7.36,0,0,0-1.7,6.45c.56,2.05,2.23,2.49,3.72,1a7.36,7.36,0,0,0,1.7-6.45C423.05,198.4,421.39,198,419.89,199.47Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.85,169.59a3.79,3.79,0,0,0-2.7,2.11,1.16,1.16,0,0,0,.1,1.27h0l22.8,27.43h0a1.26,1.26,0,0,0,1.1.28,3.79,3.79,0,0,0,2.7-2.11,1.14,1.14,0,0,0-.11-1.27h0L396,169.9h0A1.26,1.26,0,0,0,394.85,169.59Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M394.85,169.59a3.79,3.79,0,0,0-2.7,2.11,1.16,1.16,0,0,0,.1,1.27h0l22.8,27.43h0a1.26,1.26,0,0,0,1.1.28,3.79,3.79,0,0,0,2.7-2.11,1.14,1.14,0,0,0-.11-1.27h0L396,169.9h0A1.26,1.26,0,0,0,394.85,169.59Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M398.12,169.7c1.28-1.59.17-4.51-1.29-6.19s-4.2-3.17-6-2.14-7.17,5.54-7.17,5.54l8.22,9.44S396.85,171.3,398.12,169.7Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.12,169.7c1.28-1.59.17-4.51-1.29-6.19s-4.2-3.17-6-2.14-7.17,5.54-7.17,5.54l8.22,9.44S396.85,171.3,398.12,169.7Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.1,161.49c1.85,2.15.67,8.17-4.78,11.88l2.6,3s4.93-5,6.2-6.65.17-4.51-1.29-6.19A8.17,8.17,0,0,0,394.1,161.49Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,199.66c5.43-4.73,14.25-22.63,7.92-29.9s-25.27-1-30.7,3.73",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,199.66c5.43-4.73,14.25-22.63,7.92-29.9s-25.27-1-30.7,3.73",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.08,181.25c-2-7.28,2.07-10.79,9-7.85s14.15,11.23,16.11,18.51-2.07,10.78-9,7.84S360,188.52,358.08,181.25Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.08,181.25c-2-7.28,2.07-10.79,9-7.85s14.15,11.23,16.11,18.51-2.07,10.78-9,7.84S360,188.52,358.08,181.25Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.69,187.1c.13-.11.24-.22.36-.34a34.57,34.57,0,0,0-9.28-10.6l-.36.28a7.07,7.07,0,1,0,9.28,10.66Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.69,187.1c.13-.11.24-.22.36-.34a34.57,34.57,0,0,0-9.28-10.6l-.36.28a7.07,7.07,0,1,0,9.28,10.66Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-97",
    d: "M386.42,268.75,345.31,245a2.37,2.37,0,0,0-2.36,0L271.64,286.2a.53.53,0,0,0,0,.91l41.49,24Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.35,263.75v.93a3.83,3.83,0,0,1-1.9,3.29L315,306.31a3.65,3.65,0,0,1-1.89.51,3.88,3.88,0,0,1-1.91-.51L275,285.48a3.82,3.82,0,0,1-1.9-3.29v-1.28h0a.48.48,0,0,0,.24.42l39.76,23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.13,304.29v2.53a3.75,3.75,0,0,0,1.89-.51L381.45,268a3.8,3.8,0,0,0,1.9-3.3v-.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.35,263.75,344,241a2.3,2.3,0,0,0-2.27,0l-68.33,39.46a.51.51,0,0,0,0,.87l39.76,23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.77 300.95 291.52 288.7 353.64 252.84 374.99 265.02 312.77 300.95",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.99 265.02 374.18 265.49 353.64 253.77 292.34 289.17 291.53 288.7 353.64 252.84 374.99 265.02",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.33 266.87 302.72 267.1 313.13 273.11 331.64 262.41 332.03 262.19 321.23 255.96 302.33 266.87",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.72 267.1 313.13 273.11 331.64 262.41 321.23 256.4 302.72 267.1",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.2,304.85a4.46,4.46,0,0,0,3.88-.3l66.13-38.18a4.52,4.52,0,0,0,2.19-3.14l7.24-43.18a4.51,4.51,0,0,0-1.27-3.93L323.64,255.8a3.35,3.35,0,0,0-1.62,2.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.13,304.3l.45.25a3.93,3.93,0,0,0,.62.3L322,258.13a3.35,3.35,0,0,1,1.62-2.33l68.73-39.68a4.56,4.56,0,0,0-.92-.7l-68.87,39.76A3.32,3.32,0,0,0,321,257.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.66,256.68l-1.06-.61a3.24,3.24,0,0,0-.63,1.43l-7.84,46.8.45.25a3.93,3.93,0,0,0,.62.3L322,258.13A3.4,3.4,0,0,1,322.66,256.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.45,265c.48-2.89,3.47-6.73,6.66-8.58s5.4-1,4.91,1.89-3.47,6.73-6.66,8.58S351,267.89,351.45,265Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Book--inject-97"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "186.83 320.86 267.17 274.47 214.95 244.32 134.61 290.71 186.83 320.86",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.77 317.13 262.44 273.45 214.09 245.54 138.42 289.22 186.77 317.13",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.77 317.13 262.44 273.45 214.09 245.54 138.42 289.22 186.77 317.13",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.6,294.71l0-1.35c0-1.67,3-6.42,6.69-8.57l30.06-17.35v6.06Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.33,267.44,230.27,284.8c-3.72,2.13-6.7,6.9-6.69,8.56l0,1.35L177.36,268h0v-1.35c0-1.66,3-6.42,6.68-8.56l30-17.35h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.33,267.44,230.27,284.8c-3.72,2.13-6.7,6.9-6.69,8.56l0,1.35L177.36,268h0v-1.35c0-1.66,3-6.42,6.68-8.56l30.06-17.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.59,293.46l-2.88-1.67-3.8-2.2a7.53,7.53,0,0,1,4.67.68A3.92,3.92,0,0,1,223.59,293.46Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.59,293.46l-2.88-1.67-3.8-2.2a7.53,7.53,0,0,1,4.67.68A3.92,3.92,0,0,1,223.59,293.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.78 318.39 186.77 317.13 138.42 289.22 138.42 290.48 186.78 318.39",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.78 318.39 186.77 317.13 138.42 289.22 138.42 290.48 186.78 318.39",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.78 318.39 262.44 274.71 262.44 273.45 186.77 317.13 186.78 318.39",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.59,293.46c0-1.67-3.06-3.06-6.78-.93l-30.05,17.22V316l36.84-21.27S223.6,295.12,223.59,293.46Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.76 315.98 186.76 309.75 140.52 283.05 140.52 289.28 186.76 315.98",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.81,292.53l-1.34.77-28.71,16.45-40.84-23.58-5.4-3.12,30-17.21c2.73-1.57,4.25-1.44,5.32-.84h0l46.88,27.07C221.07,291.11,219.1,291.31,216.81,292.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.66 305.06 210.25 290.29 211.6 289.52 212.58 290.09 211.23 290.86 185.64 305.63 184.66 305.06",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.3 303.69 207.89 288.93 209.23 288.16 210.22 288.73 208.87 289.5 183.28 304.26 182.3 303.69",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.93 302.33 205.52 287.56 206.87 286.79 207.85 287.36 206.51 288.13 180.92 302.9 179.93 302.33",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.57 300.96 203.16 286.2 204.51 285.43 205.49 286 204.15 286.77 178.56 301.53 177.57 300.96",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.21 299.6 200.8 284.83 202.14 284.06 203.13 284.63 201.78 285.4 176.19 300.17 175.21 299.6",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.84 298.24 198.43 283.47 199.78 282.7 200.76 283.27 199.42 284.04 173.83 298.8 172.84 298.24",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.48 296.87 196.07 282.11 197.42 281.33 198.4 281.9 197.06 282.67 171.47 297.44 170.48 296.87",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.12 295.51 193.71 280.74 195.05 279.97 196.04 280.54 194.69 281.31 169.1 296.07 168.12 295.51",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.75 294.14 191.34 279.38 192.69 278.61 193.68 279.18 192.33 279.94 166.74 294.71 165.75 294.14",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.39 292.78 188.98 278.01 190.33 277.24 191.31 277.81 189.97 278.58 164.38 293.35 163.39 292.78",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.03 291.41 186.62 276.65 187.97 275.88 188.95 276.45 187.6 277.22 162.01 291.98 161.03 291.41",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.66 290.05 184.25 275.28 185.6 274.51 186.59 275.08 185.24 275.85 159.65 290.62 158.66 290.05",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.3 288.68 181.89 273.92 183.24 273.15 184.22 273.72 182.88 274.49 157.29 289.25 156.3 288.68",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.94 287.32 179.53 272.56 180.88 271.79 181.86 272.35 180.51 273.12 154.92 287.89 153.94 287.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.57 285.96 177.17 271.19 178.51 270.42 179.5 270.99 178.15 271.76 152.56 286.52 151.57 285.96",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.21 284.59 174.8 269.83 176.15 269.06 177.13 269.62 175.79 270.39 150.2 285.16 149.21 284.59",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.85 283.23 172.44 268.46 173.79 267.69 174.77 268.26 173.42 269.03 147.83 283.8 146.85 283.23",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.1,290.92c-.56.05-1.74.43-2.38.58-2.73.61-7.55,2.81-12.17,5.13-6.17,3.09-12,6.38-12,6.38l-42.3-24.4,22.3-12.77a9.74,9.74,0,0,1,2.76-1.15,5.74,5.74,0,0,1,1.92.67l.3-.52.34.16,46.88,27.07A7.61,7.61,0,0,0,217.1,290.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.73 311.11 191.32 308.78 186.76 311.56 182.18 308.91 186.73 311.11",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.77 314.22 195.18 309.37 186.77 313.89 177.31 308.76 186.77 314.22",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.52 284.43 147.59 288.69 140.52 285.08 140.52 284.43",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.53 286.86 151.03 293.28 140.52 287.44 140.53 286.86",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.91,289.59a15.48,15.48,0,0,0-1.8.31c-2.73.62-7.55,2.82-12.17,5.13-6.17,3.09-12,6.38-12,6.38l-46.27-26.68s17.61-10.13,24.52-11.47c3.24-.63,5.23-.19,6.44.5h0l45.93,26.52A7.53,7.53,0,0,0,216.91,289.59Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.33,287.24a7.53,7.53,0,0,0-4.67-.68,15.13,15.13,0,0,0-1.8.31,44.52,44.52,0,0,0-7.56,2.9c-1.5.69-3.07,1.45-4.61,2.23-3.71,1.86-7.29,3.79-9.56,5l1.05.61c2.27-1.24,5.85-3.18,9.56-5,1.55-.77,3.11-1.53,4.62-2.22a43.33,43.33,0,0,1,7.55-2.9,15.48,15.48,0,0,1,1.8-.31,7.47,7.47,0,0,1,4.67.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,285.87a7.53,7.53,0,0,0-4.67-.68,18,18,0,0,0-1.8.31,44.16,44.16,0,0,0-7.55,2.9c-1.51.7-3.07,1.46-4.62,2.23-3.71,1.86-7.29,3.79-9.56,5l1.06.6c2.26-1.24,5.84-3.17,9.55-5,1.55-.78,3.11-1.54,4.62-2.23a44.16,44.16,0,0,1,7.55-2.9,15.28,15.28,0,0,1,1.81-.31,7.55,7.55,0,0,1,4.67.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.6,284.5a7.48,7.48,0,0,0-4.67-.67,15.28,15.28,0,0,0-1.81.31,43.63,43.63,0,0,0-7.55,2.9c-1.5.69-3.07,1.45-4.61,2.22-3.72,1.86-7.3,3.8-9.56,5l1,.61c2.26-1.25,5.84-3.18,9.56-5,1.54-.77,3.11-1.53,4.61-2.23a44.48,44.48,0,0,1,7.55-2.9,17.64,17.64,0,0,1,1.81-.31,7.55,7.55,0,0,1,4.67.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.23,283.14a7.55,7.55,0,0,0-4.67-.68,14.8,14.8,0,0,0-1.8.31,44.21,44.21,0,0,0-7.56,2.9c-1.5.69-3.07,1.45-4.61,2.23-3.71,1.86-7.3,3.79-9.56,5l1.05.61c2.27-1.25,5.85-3.18,9.56-5,1.54-.77,3.11-1.53,4.61-2.22a43.68,43.68,0,0,1,7.56-2.9,15.13,15.13,0,0,1,1.8-.31,7.48,7.48,0,0,1,4.67.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.86,281.77a7.53,7.53,0,0,0-4.67-.68,17.48,17.48,0,0,0-1.8.31,44.16,44.16,0,0,0-7.55,2.9c-1.51.7-3.07,1.46-4.62,2.23-3.71,1.86-7.29,3.79-9.56,5l1.05.6c2.27-1.24,5.85-3.17,9.56-5,1.55-.78,3.11-1.54,4.62-2.23a44.16,44.16,0,0,1,7.55-2.9,15.48,15.48,0,0,1,1.8-.31,7.53,7.53,0,0,1,4.67.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.5,280.4a7.48,7.48,0,0,0-4.67-.67A15.28,15.28,0,0,0,198,280a43.33,43.33,0,0,0-7.55,2.9c-1.51.69-3.07,1.45-4.62,2.22-3.71,1.86-7.29,3.79-9.55,5l1,.61c2.26-1.25,5.84-3.18,9.55-5,1.55-.77,3.11-1.53,4.62-2.23a44.16,44.16,0,0,1,7.55-2.9,17.64,17.64,0,0,1,1.81-.31,7.55,7.55,0,0,1,4.67.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.13,279a7.55,7.55,0,0,0-4.67-.68,15.28,15.28,0,0,0-1.81.31,44.48,44.48,0,0,0-7.55,2.9c-1.5.69-3.07,1.45-4.61,2.23-3.72,1.86-7.3,3.79-9.56,5l1,.61c2.26-1.25,5.84-3.18,9.56-5,1.54-.77,3.11-1.53,4.61-2.22a43.37,43.37,0,0,1,7.56-2.9,14.8,14.8,0,0,1,1.8-.31,7.48,7.48,0,0,1,4.67.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.76,277.67a7.53,7.53,0,0,0-4.67-.68,15.13,15.13,0,0,0-1.8.31,44.52,44.52,0,0,0-7.56,2.9c-1.5.7-3.07,1.46-4.61,2.23-3.71,1.86-7.29,3.79-9.56,5l1.05.6c2.27-1.24,5.85-3.17,9.56-5,1.54-.78,3.11-1.54,4.61-2.23a44.52,44.52,0,0,1,7.56-2.9,15.13,15.13,0,0,1,1.8-.31,7.53,7.53,0,0,1,4.67.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.77,276.23a18,18,0,0,0-1.8.31c-2.73.62-7.55,2.82-12.17,5.13-3.71,1.86-7.29,3.79-9.56,5l-1.05-.61c2.27-1.25,5.85-3.18,9.56-5,4.62-2.31,9.44-4.51,12.17-5.12a15.48,15.48,0,0,1,1.8-.31,7.47,7.47,0,0,1,4.67.67l1.05.61A7.52,7.52,0,0,0,193.77,276.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.41,274.87a15.28,15.28,0,0,0-1.81.31c-2.73.61-7.55,2.81-12.16,5.12-3.72,1.86-7.3,3.79-9.56,5l-1-.61c2.26-1.24,5.84-3.17,9.56-5,4.61-2.32,9.43-4.52,12.16-5.13a15.28,15.28,0,0,1,1.81-.31,7.55,7.55,0,0,1,4.67.68l1.05.6A7.48,7.48,0,0,0,191.41,274.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,273.5a14.8,14.8,0,0,0-1.8.31c-2.74.61-7.56,2.81-12.17,5.13-3.71,1.85-7.3,3.79-9.56,5l-1-.6c2.26-1.25,5.85-3.18,9.56-5,4.61-2.31,9.43-4.51,12.17-5.13a14.8,14.8,0,0,1,1.8-.31,7.55,7.55,0,0,1,4.67.68l1.05.61A7.55,7.55,0,0,0,189,273.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.67,272.13a15.48,15.48,0,0,0-1.8.31c-2.73.62-7.55,2.82-12.17,5.13-3.71,1.86-7.29,3.79-9.56,5l-1-.61c2.27-1.25,5.85-3.18,9.56-5,4.62-2.31,9.44-4.51,12.17-5.13a17.29,17.29,0,0,1,1.8-.3,7.47,7.47,0,0,1,4.67.67l1.05.61A7.53,7.53,0,0,0,186.67,272.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.31,270.77a17.46,17.46,0,0,0-1.81.3c-2.73.62-7.55,2.82-12.17,5.13-3.71,1.86-7.29,3.79-9.55,5l-1.05-.61c2.26-1.24,5.84-3.18,9.55-5,4.62-2.32,9.44-4.52,12.17-5.13a15.48,15.48,0,0,1,1.8-.31,7.57,7.57,0,0,1,4.68.68l1,.6A7.48,7.48,0,0,0,184.31,270.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.94,269.4a14.8,14.8,0,0,0-1.8.31c-2.74.61-7.56,2.81-12.17,5.13-3.72,1.86-7.3,3.79-9.56,5l-1-.6c2.26-1.25,5.84-3.18,9.56-5,4.61-2.31,9.43-4.51,12.16-5.13a15.28,15.28,0,0,1,1.81-.31,7.55,7.55,0,0,1,4.67.68l1.05.61A7.55,7.55,0,0,0,181.94,269.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.57,268a15.13,15.13,0,0,0-1.8.31c-2.74.62-7.55,2.82-12.17,5.13-3.71,1.86-7.29,3.79-9.56,5l-1-.61c2.27-1.25,5.85-3.18,9.56-5,4.61-2.31,9.43-4.51,12.17-5.13a17.29,17.29,0,0,1,1.8-.3,7.48,7.48,0,0,1,4.67.67l1.05.61A7.53,7.53,0,0,0,179.57,268Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.2,266.67a17.74,17.74,0,0,0-1.8.3c-2.73.62-7.55,2.82-12.17,5.13-3.71,1.86-7.29,3.79-9.56,5l-1-.61c2.27-1.24,5.85-3.18,9.56-5,4.62-2.32,9.44-4.52,12.17-5.13a15.48,15.48,0,0,1,1.8-.31,7.53,7.53,0,0,1,4.67.68l1.05.6A7.47,7.47,0,0,0,177.2,266.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.84,265.3a15.28,15.28,0,0,0-1.81.31c-2.73.61-7.55,2.81-12.16,5.13-3.72,1.85-7.3,3.79-9.56,5l-1.05-.6c2.26-1.25,5.84-3.18,9.55-5,4.62-2.31,9.44-4.51,12.17-5.13a15.28,15.28,0,0,1,1.81-.31,7.55,7.55,0,0,1,4.67.68l1,.61A7.55,7.55,0,0,0,174.84,265.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.94,282.3a15,15,0,0,0-3.74,3.2l-1-.55a14.86,14.86,0,0,1,3.74-3.21l26.94-15.52,1,.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.94,282.3a15,15,0,0,0-3.74,3.2l-1-.55a14.86,14.86,0,0,1,3.74-3.21l26.94-15.52,1,.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.48,285.07l.39-.44a15.36,15.36,0,0,1,3.87-3.31l27.18-15.66,1.93,1.12-27.67,15.94a14.5,14.5,0,0,0-3.61,3.1l-.27.3Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.58,280.93a15.08,15.08,0,0,0-3.75,3.21l-1-.56a15.2,15.2,0,0,1,3.74-3.2l26.95-15.52,1,.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.21,279.57a15,15,0,0,0-3.74,3.2l-1-.55a14.86,14.86,0,0,1,3.74-3.21l26.94-15.52,1,.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.85,278.2a15.08,15.08,0,0,0-3.75,3.21l-1-.56a15,15,0,0,1,3.75-3.2l26.94-15.52,1,.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.48,276.84a15.2,15.2,0,0,0-3.74,3.2l-1-.56a15,15,0,0,1,3.74-3.2l26.94-15.52,1,.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.12,275.47a14.86,14.86,0,0,0-3.74,3.21l-1-.56a15.25,15.25,0,0,1,3.75-3.2L240.1,259.4l1,.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.75,274.11a15,15,0,0,0-3.74,3.2l-1-.56a15.2,15.2,0,0,1,3.74-3.2L237.73,258l1,.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.39,272.74a15,15,0,0,0-3.74,3.2l-1-.55a15,15,0,0,1,3.75-3.2l26.94-15.52,1,.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,271.38a15,15,0,0,0-3.74,3.2l-1-.56a15.2,15.2,0,0,1,3.74-3.2L233,255.3l1,.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.66,270a15,15,0,0,0-3.74,3.2l-1-.55a14.82,14.82,0,0,1,3.74-3.2l26.94-15.52,1,.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.3,268.65a15,15,0,0,0-3.75,3.2l-1-.56a15.2,15.2,0,0,1,3.74-3.2l26.95-15.52,1,.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.93,267.28a15,15,0,0,0-3.74,3.2l-1-.55a14.82,14.82,0,0,1,3.74-3.2l26.94-15.52,1,.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.57,265.92a15,15,0,0,0-3.75,3.2l-1-.56a15.25,15.25,0,0,1,3.75-3.2l26.94-15.52,1,.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.2,264.55a15.2,15.2,0,0,0-3.74,3.2l-1-.55a14.82,14.82,0,0,1,3.74-3.2l26.94-15.52,1,.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.84,263.19a15,15,0,0,0-3.75,3.2l-1-.56a15.25,15.25,0,0,1,3.75-3.2l26.94-15.52,1,.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.47,261.82a15.2,15.2,0,0,0-3.74,3.2l-1-.55a14.82,14.82,0,0,1,3.74-3.2l26.94-15.52,1,.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.11,260.46a14.82,14.82,0,0,0-3.74,3.2l-1-.56a15.25,15.25,0,0,1,3.75-3.2l26.94-15.52,1,.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.14,283.68l.39-.45a15.51,15.51,0,0,1,3.87-3.3l27.18-15.66,1.93,1.11-27.67,15.94a14.75,14.75,0,0,0-3.62,3.1l-.26.31Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.8,282.28l.39-.44a15.5,15.5,0,0,1,3.86-3.31l27.19-15.66,1.93,1.12L221.5,279.93a14.36,14.36,0,0,0-3.62,3.1l-.26.3Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.46,280.89l.38-.45a15.48,15.48,0,0,1,3.87-3.3l27.19-15.66,1.93,1.11-27.67,15.94a14.57,14.57,0,0,0-3.62,3.1l-.26.31Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.3,272.65l.38-.44a15.56,15.56,0,0,1,3.87-3.31l27.18-15.66,1.94,1.12L205,270.3a14.57,14.57,0,0,0-3.62,3.1l-.27.3Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,271.26l.39-.45a15.51,15.51,0,0,1,3.87-3.3l27.18-15.66,1.93,1.12L202.65,268.9A14.71,14.71,0,0,0,199,272l-.27.31Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.61,269.86l.39-.44a15.36,15.36,0,0,1,3.87-3.31l27.18-15.66,1.93,1.12-27.67,15.94a14.93,14.93,0,0,0-3.62,3.1l-.26.3Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.02 272.74 260.32 269.42 260.32 268.9 254.02 272.74",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.33 271.27 249.82 277.14 260.33 270.89 260.33 271.27",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.91,270.77c5.68-3,13.29-6.73,17.3-7.51,3.24-.63,5.23-.19,6.44.5h0l45.93,26.52a7.53,7.53,0,0,0-4.67-.68S194.18,275.72,179.5,271A47.3,47.3,0,0,0,151.91,270.77Z",
    style: {
      opacity: 0.02
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Books--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-97",
    d: "M238,352.23,197,328.59a1.16,1.16,0,0,1,0-2.2l54.83-31.65a4.22,4.22,0,0,1,3.82,0l40.93,23.63a1.16,1.16,0,0,1,0,2.2l-54.83,31.66A4.28,4.28,0,0,1,238,352.23Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--book--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203,327.93l1.45-.77-1.32-.32A1,1,0,0,0,203,327.93Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,327.93l1.45-.77-1.32-.32A1,1,0,0,0,203,327.93Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.43,347.3a3.26,3.26,0,0,1-3,0l-33.14-19.14L255,300l1.16-.67L289.25,318a.91.91,0,0,1,0,1.71Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,311.62l-11.56,6.65L210,314l-8.7,5v5.8c0,.76.85,1.85,1.16,1.67a8.57,8.57,0,0,1,1.66.59,12.34,12.34,0,0,1,2.41,1.78L233,314Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,311.62l-11.56,6.65L210,314l-8.7,5v5.8c0,.76.85,1.85,1.16,1.67a8.57,8.57,0,0,1,1.66.59,12.34,12.34,0,0,1,2.41,1.78L233,314Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,319.68V326a.53.53,0,0,0-.1-.06,2.91,2.91,0,0,0-1.41-.45,1.5,1.5,0,0,0-.94.22v-7.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.65,328.15a1.9,1.9,0,0,0-.42-1.08,5.85,5.85,0,0,0-.4-.47l-.14-.13-.19-.15-.15-.12L206,326V319.7l1.62.94v7.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.25,324.78c0,.76.85,1.85,1.16,1.67h0l1.16-.76V320.9l-1.16-2-.64-.23-.52.31Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,339.27v7.19a1.92,1.92,0,0,1-1-.23l-3.64-2.1-27.69-16v-7.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.42,312.25v5.43a2.18,2.18,0,0,1-1,1.7l-42.87,24.75-3.63,2.1a2,2,0,0,1-1,.23v-6.38Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,290.64l-49.61,28.64V320c0,.36-.52.5-1.15.13s-1.16-.83-1.16-1.46L203,318l50.54-29.17.21-.12a.64.64,0,0,1,.08.3v.31C253.8,289.67,254.31,290.26,255,290.64Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,290.64l-49.61,28.64V320c0,.36-.52.5-1.15.13s-1.16-.83-1.16-1.46L203,318l50.54-29.17.21-.12a.64.64,0,0,1,.08.3v.31C253.8,289.67,254.31,290.26,255,290.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.48,338.42l-32.4-18.72c-.42-.21-.79-.38-1-.3l.21-.12L255,290.64l.58-.34a1.88,1.88,0,0,1,1.56.23l32.16,18.57a.9.9,0,0,1,0,1.7l-47.82,27.62A3.26,3.26,0,0,1,238.48,338.42Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.72,288.69l-.21.12L203,318a.56.56,0,0,0-.11-.13l-.17-.1-.37-.21-.44-.26a.46.46,0,0,0-.58.05l-.06.05-.15.21a1.28,1.28,0,0,0-.13.29,2.58,2.58,0,0,0-.1.33c0,.12-.05.25-.08.38a1.94,1.94,0,0,0,0,.24,1.1,1.1,0,0,0,0,.18c0,.15,0,.29,0,.45V318a3.06,3.06,0,0,1,1.48-2.28L250,288.15a3,3,0,0,1,2.63-.19l.6.36h0l.26.15h0A.64.64,0,0,1,253.72,288.69Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.48,347.3l-2-1.16-30-17.33a2,2,0,0,0-.41-1.07,4.19,4.19,0,0,0-1.31-1.15,3,3,0,0,0-1.42-.45,1.53,1.53,0,0,0-.93.31,5.21,5.21,0,0,1-.55-2.48h-1.14c0,1.57.52,3.14,1.16,3.5l.57.34c.32.19.58.2.58,0v-.31c0-.34.52-.32,1.16.05s1.15.94,1.15,1.28v.31c0,.18.44.57,1,.88l29,16.76,3.14,1.81h0A3,3,0,0,0,240,349v-1.31A3,3,0,0,1,238.48,347.3Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.48,347.3l-2-1.16-30-17.33a2,2,0,0,0-.41-1.07,4.19,4.19,0,0,0-1.31-1.15,3,3,0,0,0-1.42-.45,1.53,1.53,0,0,0-.93.31,5.21,5.21,0,0,1-.55-2.48h-1.14c0,1.57.52,3.14,1.16,3.5l.57.34c.32.19.58.2.58,0v-.31c0-.34.52-.32,1.16.05s1.15.94,1.15,1.28v.31c0,.18.44.57,1,.88l29,16.76,3.14,1.81h0A3,3,0,0,0,240,349v-1.31A3,3,0,0,1,238.48,347.3Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.49,338.42h0l-2-1.16-23-13.3-7.36-4.25c-.52-.31-.95-.42-1-.26s0,0,0,0v.33c0,.37-.52.37-1.15,0a1.51,1.51,0,0,1-.91-1.16v-.36a.54.54,0,0,0-.17-.43l-.17-.1-.37-.21-.44-.26a.46.46,0,0,0-.58.05l-.06.05a.71.71,0,0,0-.1.14l0,.07a1.28,1.28,0,0,0-.13.29,2.58,2.58,0,0,0-.1.33c0,.12-.05.25-.08.38a1.94,1.94,0,0,0,0,.24,1.1,1.1,0,0,0,0,.18c0,.15,0,.29,0,.45V324h1.14v-4.51c0-.12,0-.24,0-.36l0-.28v0a3.29,3.29,0,0,0,1.72,2.14,2.82,2.82,0,0,0,1.39.43,1.49,1.49,0,0,0,1-.38l.1.06.2.12,29,16.76,3.14,1.81h0l0,0a3.07,3.07,0,0,0,1.45.33v-1.31A3,3,0,0,1,238.49,338.42Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.49,338.42h0l-2-1.16-23-13.3-7.36-4.25c-.52-.31-.95-.42-1-.26s0,0,0,0v.33c0,.37-.52.37-1.15,0a1.51,1.51,0,0,1-.91-1.16v-.36a.54.54,0,0,0-.17-.43l-.17-.1-.37-.21-.44-.26a.46.46,0,0,0-.58.05l-.06.05a.71.71,0,0,0-.1.14l0,.07a1.28,1.28,0,0,0-.13.29,2.58,2.58,0,0,0-.1.33c0,.12-.05.25-.08.38a1.94,1.94,0,0,0,0,.24,1.1,1.1,0,0,0,0,.18c0,.15,0,.29,0,.45V324h1.14v-4.51c0-.12,0-.24,0-.36l0-.28v0a3.29,3.29,0,0,0,1.72,2.14,2.82,2.82,0,0,0,1.39.43,1.49,1.49,0,0,0,1-.38l.1.06.2.12,29,16.76,3.14,1.81h0l0,0a3.07,3.07,0,0,0,1.45.33v-1.31A3,3,0,0,1,238.49,338.42Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.86,309.94v1.33a1,1,0,0,1-.59.84h0l-44.68,25.8-3.14,1.81h0a3.07,3.07,0,0,1-1.47.35v-1.31a2.93,2.93,0,0,0,1.47-.35l2-1.16h0l45.82-26.46A1,1,0,0,0,289.86,309.94Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.86,309.94v1.33a1,1,0,0,1-.59.84h0l-44.68,25.8-3.14,1.81h0a3.07,3.07,0,0,1-1.47.35v-1.31a2.93,2.93,0,0,0,1.47-.35l2-1.16h0l45.82-26.46A1,1,0,0,0,289.86,309.94Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.86,318.82v1.33a1,1,0,0,1-.59.84h0l-44.68,25.8-3.14,1.81h0A3.07,3.07,0,0,1,240,349v-1.31a2.93,2.93,0,0,0,1.47-.35l2-1.16h0l45.82-26.46A1,1,0,0,0,289.86,318.82Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.86,318.82v1.33a1,1,0,0,1-.59.84h0l-44.68,25.8-3.14,1.81h0A3.07,3.07,0,0,1,240,349v-1.31a2.93,2.93,0,0,0,1.47-.35l2-1.16h0l45.82-26.46A1,1,0,0,0,289.86,318.82Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--book--inject-97"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "202.97 313.38 241.71 335.46 293.25 305.88 254.5 283.81 202.97 313.38",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.97 313.38 241.71 335.46 293.25 305.88 254.5 283.81 202.97 313.38",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.07,334.1l-37.65-21.55a12.47,12.47,0,0,0-.16-7.81l37.45,21.38S242.29,328,242.07,334.1Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.18,323.68a6.33,6.33,0,0,1,2.89,5v5.81c0,1.84-1.29,2.58-2.89,1.66L203,314.82v-1.44l36.81,21c1,.55,1.73.1,1.73-1l0-5.39a3.82,3.82,0,0,0-1.74-3L203,304v-1.64Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.18,323.68a6.33,6.33,0,0,1,2.89,5v5.81c0,1.84-1.29,2.58-2.89,1.66L203,314.82v-1.44l36.81,21c1,.55,1.73.1,1.73-1l0-5.39a3.82,3.82,0,0,0-1.74-3L203,304v-1.64Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,302.38,254.5,272.8l37.21,21.31a6.34,6.34,0,0,1,2.89,5v5.81a2,2,0,0,1-.85,1.86l-51.53,29.57a2,2,0,0,0,.85-1.85v-5.82a6.32,6.32,0,0,0-2.89-5Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,302.38,254.5,272.8l37.21,21.31a6.34,6.34,0,0,1,2.89,5v5.81a2,2,0,0,1-.85,1.86l-51.53,29.57a2,2,0,0,0,.85-1.85v-5.82a6.32,6.32,0,0,0-2.89-5Z",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.23,325.82a5.89,5.89,0,0,1,.84,2.84v5.82a2,2,0,0,1-.85,1.85l51.53-29.57a2,2,0,0,0,.85-1.86v-5.81a5.79,5.79,0,0,0-.85-2.84Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.23,325.82a5.89,5.89,0,0,1,.84,2.84v5.82a2,2,0,0,1-.85,1.85l51.53-29.57a2,2,0,0,0,.85-1.86v-5.81a5.79,5.79,0,0,0-.85-2.84Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,300.11a20.26,20.26,0,0,1,0,10.57l-2.39,1.38a20.36,20.36,0,0,0,0-10.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.73,319.87a20.15,20.15,0,0,1,0,10.57l-2.39,1.38a20.26,20.26,0,0,0,0-10.57Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pen--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-97",
    d: "M351.85,222.32l-3-3.44h0L326.07,205.7h0l-.64-.37-1-.6-.07,0h0l-1-.58h0l-4.11-2.37c-.79-.54-2,.56-2.44,1.67h0a2.54,2.54,0,0,0-.17.51A1,1,0,0,0,317,205L320.3,207l.91.53h0l.75.44.07,0,.87.5h0s0,0,0,0l.73.42,23.15,13.4h0l4.41.88,1.19.23a.2.2,0,0,0,.16,0,.17.17,0,0,0,0-.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pencil--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.64,205.51l.41.23.5.29,25.84,15a2.25,2.25,0,0,1,.31-1.7c.42-.77,1.05-1.38,1.5-1.41L323.49,203l-.95-.54C323.14,202.84,321.24,205.89,320.64,205.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.45,203l-.92-.53c-.26-.16-.76.31-1.19.93-.58.82-1,1.92-.7,2.13l.67.39.25.13c-.35-.21.12-1.3.7-2.13.42-.59.89-1.05,1.16-.94h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.22,202.85c-.61-.38-2.5,2.68-1.89,3.05l.92.53c-.61-.37,1.28-3.43,1.89-3.05Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,203.88l-.9-.52c-.6-.38-2.45,2.56-1.95,3l0,0,.92.52C322.51,206.54,324.41,203.5,325,203.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.54,202.45h0c-.26-.16-.75.31-1.19.93-.57.81-1,1.88-.72,2.12l-3.83-2.21a.92.92,0,0,1-.3-1c.21-1.11,1.52-2.53,2.35-2Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.65,221.13c-.32.43-.29.64-.29.64l-4-.78a2.11,2.11,0,0,1,.41-2.28l.17.1Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.44,222l-1.08-.21s-.05-.21.29-.64l.94.6h0a.16.16,0,0,1,0,.22A.13.13,0,0,1,352.44,222Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.2,217.88h0l2.73,3.1a.48.48,0,0,0-.28.15L348,218.81l-.17-.1A1.92,1.92,0,0,1,349.2,217.88Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.65,221.13a.36.36,0,0,1,.28-.15l.66.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.8,218.71l-30.92-17.35a2.85,2.85,0,0,0-.39.93.92.92,0,0,0,.3,1l3.85,2.22.41.23.5.29,25.84,15A2.15,2.15,0,0,1,347.8,218.71Z",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pen--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.35,199.7l30.94,17.89,4.78,1a.15.15,0,0,0,.16-.21l-1.5-2.75-30.94-17.89C327.84,197.17,324.61,199.27,325.35,199.7Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pen--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.43,195l.14.05-.27-.15-.05,0h0l-.05,0h0l0,0H328a1.12,1.12,0,0,0-.57.17,2.82,2.82,0,0,0-1.28,2.22,1.58,1.58,0,0,0,0,.32s0,0,0,.06a0,0,0,0,1,0,0l0,.06a.57.57,0,0,0,.1.19.53.53,0,0,0,.19.17l.31.18-.14-.11a1,1,0,0,0,.74-.16,2.85,2.85,0,0,0,1.28-2.22A1,1,0,0,0,328.43,195Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.25,212.21l-1.8,3.14-.31-.18-29.35-16.95-.14-.11a1,1,0,0,1-.24-.72,2.83,2.83,0,0,1,1.29-2.22,1.14,1.14,0,0,1,.57-.18l.16,0,.14.05h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.35,212.3c.7-.41,1.28-.08,1.28.74a2.85,2.85,0,0,1-1.28,2.22c-.71.41-1.28.08-1.28-.74A2.82,2.82,0,0,1,357.35,212.3Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.1,214.2l0,0-1.64-1.8h0l0,0,0,0h0a.83.83,0,0,0-1,0,2.82,2.82,0,0,0-1.28,2.22.84.84,0,0,0,.49.88h0l.09,0h0l2.37.52a.6.6,0,0,0,.41-.09,1.62,1.62,0,0,0,.74-1.27A.62.62,0,0,0,360.1,214.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.19,200.81h0l0,0a.31.31,0,0,0-.3,0,1,1,0,0,0-.46.79.35.35,0,0,0,.11.28h0l.06,0,22.44,13,1.28-.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.18,213.84l1.81,1,1.28-.74-2.45-1.42A3.25,3.25,0,0,0,356.18,213.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.75,215.06h0l-1.49-1.63a.1.1,0,0,0,0-.05.58.58,0,0,0-.73,0,2,2,0,0,0-.9,1.56c0,.34.13.56.34.63H358l2.17.48h0a.37.37,0,0,0,.24-.05.93.93,0,0,0,.41-.72A.32.32,0,0,0,360.75,215.06Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.75,215.06h0l-1.49-1.63a.1.1,0,0,0,0-.05.58.58,0,0,0-.73,0,2,2,0,0,0-.9,1.56c0,.34.13.56.34.63H358l2.17.48h0a.37.37,0,0,0,.24-.05.93.93,0,0,0,.41-.72A.32.32,0,0,0,360.75,215.06Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.83,215.29a.93.93,0,0,1-.41.72.37.37,0,0,1-.24.05h0l-1.1-.24c-.17,0-.28-.2-.28-.46a1.47,1.47,0,0,1,.65-1.15.43.43,0,0,1,.53,0l0,0,.74.81h0A.32.32,0,0,1,360.83,215.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.42,215.05c.22-.13.41,0,.41.24a.93.93,0,0,1-.41.72c-.23.13-.42,0-.42-.24A.94.94,0,0,1,360.42,215.05Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.34,198a.32.32,0,0,0-.32,0,1,1,0,0,0-.46.78.31.31,0,0,0,.14.3h0l4.79,2.77a.35.35,0,0,1-.11-.28,1,1,0,0,1,.46-.79.31.31,0,0,1,.3,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.47,198.3a1,1,0,0,1-.45.79.34.34,0,0,1-.32,0,.34.34,0,0,1-.14-.3A1,1,0,0,1,331,198a.32.32,0,0,1,.32,0A.31.31,0,0,1,331.47,198.3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.46,196.36h0l-1.89-1.09,0,0h0a.86.86,0,0,0-.79.09,2.58,2.58,0,0,0-1.15,2,.81.81,0,0,0,.34.75h0l1.92,1.11h0a.82.82,0,0,0,.8-.09,2.57,2.57,0,0,0,1.15-2A.84.84,0,0,0,330.46,196.36Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.46,196.36h0l-1.89-1.09,0,0h0a.86.86,0,0,0-.79.09,2.58,2.58,0,0,0-1.15,2,.81.81,0,0,0,.34.75h0l1.92,1.11h0a.82.82,0,0,0,.8-.09,2.57,2.57,0,0,0,1.15-2A.84.84,0,0,0,330.46,196.36Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.62,196.42c.63-.36,1.15-.07,1.15.67a2.57,2.57,0,0,1-1.15,2c-.64.37-1.16.07-1.16-.67A2.56,2.56,0,0,1,329.62,196.42Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.35,215.74h0l-.78-.47h0a.12.12,0,0,0-.15,0,.45.45,0,0,0-.22.36.15.15,0,0,0,.07.14h0l.78.47h0a.33.33,0,0,0,.14,0,.3.3,0,0,0,.16-.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.4,215.78h0l0,0h0a.17.17,0,0,0-.13,0,.47.47,0,0,0-.22.36.17.17,0,0,0,.06.14h0a.18.18,0,0,0,.1,0,.3.3,0,0,0,.3-.3A.28.28,0,0,0,361.4,215.78Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sheets--inject-97"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M232,246.91l45.88,26.48a2.8,2.8,0,0,0,2.58,0l33.77-19.49a.79.79,0,0,0,0-1.49l-45.88-26.49a2.88,2.88,0,0,0-2.59,0L232,245.41A.79.79,0,0,0,232,246.91Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M232,244.52,277.89,271a2.8,2.8,0,0,0,2.58,0l33.77-19.49a.79.79,0,0,0,0-1.49l-45.88-26.49a2.88,2.88,0,0,0-2.59,0L232,243A.79.79,0,0,0,232,244.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.77,223.53,233.71,242l44.18,25.51a2.86,2.86,0,0,0,2.58,0L312.53,249l-44.17-25.51A2.88,2.88,0,0,0,265.77,223.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,239.85l45.88,26.49a2.86,2.86,0,0,0,2.58,0l33.77-19.49a.79.79,0,0,0,0-1.49l-45.88-26.49a2.88,2.88,0,0,0-2.59,0L232,238.36A.79.79,0,0,0,232,239.85Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notebooks--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.86,251.28a2.32,2.32,0,0,1-1.14-.28l-44-25.42a1.2,1.2,0,0,1,0-2.17L288.63,205l47,27.16L303,251A2.39,2.39,0,0,1,301.86,251.28Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.1,203.49l-33.41,17.59-.69,1.08V223a1.24,1.24,0,0,0,.69,1.08l44,25.42a2.22,2.22,0,0,0,1.14.29,2.28,2.28,0,0,0,1.15-.29l32.66-18.85v-.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.86,249a2.22,2.22,0,0,1-1.14-.29l-44-25.42a1.19,1.19,0,0,1,0-2.16l31.94-18.44,47,27.17L303,248.66A2.28,2.28,0,0,1,301.86,249Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.62,200.09l-31.57,18.23-.33.45v3.39h0a.53.53,0,0,0,.33.45l44,25.43a1.74,1.74,0,0,0,1.57,0l31.57-18.23v-3.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.23,226.42l-.4.23-5.14,3-.95.56-25.09,14.48a1.74,1.74,0,0,1-1.57,0l-44-25.43a.48.48,0,0,1,0-.9l.42-.24,31.15-18,45.21,26.1.1.06Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.86,244.84v3.38a1.63,1.63,0,0,1-.78-.18l-44-25.43a.52.52,0,0,1-.32-.45v-3.39a.53.53,0,0,0,.32.45l44,25.43A1.64,1.64,0,0,0,301.86,244.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.23,226l-5.69,3.28-.89.51-25,14.44a1.74,1.74,0,0,1-1.57,0l-39.43-22.77-1-.57a9.67,9.67,0,0,1-3.19-2.78l-.08-.12a.77.77,0,0,1-.1-.23.71.71,0,0,1,.55-.8,14.42,14.42,0,0,0,3-1.24l0,0,27.76-16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.34,225.57a.45.45,0,0,0,0,.85,1.63,1.63,0,0,0,1.46,0c.41-.24.41-.62,0-.85A1.57,1.57,0,0,0,328.34,225.57Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,222.82a1.94,1.94,0,0,0-2,.14,6.13,6.13,0,0,0-2.47,3.56,1.36,1.36,0,0,0,.54.07,5.5,5.5,0,0,1,2.21-3.16,1.85,1.85,0,0,1,.89-.27,1,1,0,0,1,.53.13,2,2,0,0,1,.75,1.82,3.11,3.11,0,0,1,0,.43l.51.3a4.59,4.59,0,0,0,.06-.73A2.52,2.52,0,0,0,333,222.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,226.12a.69.69,0,0,1,0,.13l-.1-.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.93,223a.45.45,0,0,0,0,.85,1.63,1.63,0,0,0,1.46,0c.41-.24.41-.62,0-.85A1.63,1.63,0,0,0,323.93,223Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.63,220.27a1.94,1.94,0,0,0-2,.14,6.13,6.13,0,0,0-2.47,3.57,1.57,1.57,0,0,0,.54.06,5.54,5.54,0,0,1,2.2-3.16,1.88,1.88,0,0,1,.9-.27,1,1,0,0,1,.53.14,2,2,0,0,1,.74,1.81,3.1,3.1,0,0,1,0,.43l.51.3a4.59,4.59,0,0,0,.06-.73A2.52,2.52,0,0,0,328.63,220.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.51,220.47a.45.45,0,0,0,0,.85,1.59,1.59,0,0,0,1.47,0,.45.45,0,0,0,0-.85A1.65,1.65,0,0,0,319.51,220.47Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.22,217.73a1.91,1.91,0,0,0-2,.13,6.14,6.14,0,0,0-2.48,3.57,1.63,1.63,0,0,0,.54.06,5.55,5.55,0,0,1,2.21-3.16,1.85,1.85,0,0,1,.9-.27,1.08,1.08,0,0,1,.53.14,2,2,0,0,1,.74,1.81,3.25,3.25,0,0,1,0,.44l.52.29a4.48,4.48,0,0,0,.05-.73A2.51,2.51,0,0,0,324.22,217.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.1,217.92a.45.45,0,0,0,0,.85,1.59,1.59,0,0,0,1.47,0,.45.45,0,0,0,0-.85A1.65,1.65,0,0,0,315.1,217.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.81,215.18a1.94,1.94,0,0,0-2,.14,6.11,6.11,0,0,0-2.48,3.56,1.6,1.6,0,0,0,.54.07,5.47,5.47,0,0,1,2.21-3.16,1.87,1.87,0,0,1,.9-.28,1.08,1.08,0,0,1,.53.14,2,2,0,0,1,.74,1.81,3.25,3.25,0,0,1,0,.44l.52.3a6.27,6.27,0,0,0,.05-.74A2.52,2.52,0,0,0,319.81,215.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.69,215.38a.45.45,0,0,0,0,.85,1.63,1.63,0,0,0,1.46,0c.41-.24.41-.62,0-.85A1.57,1.57,0,0,0,310.69,215.38Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.39,212.63a1.94,1.94,0,0,0-2,.14,6.13,6.13,0,0,0-2.47,3.56,1.36,1.36,0,0,0,.54.07,5.5,5.5,0,0,1,2.21-3.16,1.84,1.84,0,0,1,.89-.28,1,1,0,0,1,.53.14,2,2,0,0,1,.74,1.82,3.1,3.1,0,0,1,0,.43l.51.3a4.59,4.59,0,0,0,.06-.73A2.51,2.51,0,0,0,315.39,212.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.28,212.83c-.41.23-.41.61,0,.85a1.63,1.63,0,0,0,1.46,0c.41-.24.41-.62,0-.85A1.57,1.57,0,0,0,306.28,212.83Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,210.08a1.94,1.94,0,0,0-2,.14,6.19,6.19,0,0,0-2.48,3.56,1.41,1.41,0,0,0,.54.07,5.55,5.55,0,0,1,2.21-3.16,1.85,1.85,0,0,1,.9-.27,1.07,1.07,0,0,1,.53.13,2,2,0,0,1,.74,1.82c0,.14,0,.29,0,.43l.51.3a4.56,4.56,0,0,0,.05-.73A2.54,2.54,0,0,0,311,210.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.86,210.28a.45.45,0,0,0,0,.85,1.65,1.65,0,0,0,1.47,0,.45.45,0,0,0,0-.85A1.65,1.65,0,0,0,301.86,210.28Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.57,207.54a1.91,1.91,0,0,0-2,.13,6.14,6.14,0,0,0-2.48,3.57,1.63,1.63,0,0,0,.54.06,5.5,5.5,0,0,1,2.21-3.16,1.85,1.85,0,0,1,.9-.27,1.08,1.08,0,0,1,.53.14,2,2,0,0,1,.74,1.81,3.25,3.25,0,0,1,0,.44l.52.29a6,6,0,0,0,.05-.73A2.51,2.51,0,0,0,306.57,207.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.45,207.73a.45.45,0,0,0,0,.85,1.57,1.57,0,0,0,1.46,0c.41-.23.41-.61,0-.85A1.63,1.63,0,0,0,297.45,207.73Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.15,205a1.94,1.94,0,0,0-2,.14,6.1,6.1,0,0,0-2.47,3.56,1.57,1.57,0,0,0,.54.06,5.45,5.45,0,0,1,2.21-3.15,1.84,1.84,0,0,1,.89-.28,1,1,0,0,1,.53.14,2,2,0,0,1,.74,1.81,3.24,3.24,0,0,1,0,.44l.51.29a4.49,4.49,0,0,0,.06-.73A2.49,2.49,0,0,0,302.15,205Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,205.19a.44.44,0,0,0,0,.84,1.57,1.57,0,0,0,1.46,0,.44.44,0,0,0,0-.84A1.57,1.57,0,0,0,293,205.19Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.74,202.44a1.94,1.94,0,0,0-2,.14,6.13,6.13,0,0,0-2.47,3.56,1.55,1.55,0,0,0,.53.07,5.56,5.56,0,0,1,2.21-3.16,1.9,1.9,0,0,1,.9-.28,1.08,1.08,0,0,1,.53.14,2,2,0,0,1,.74,1.81,3.24,3.24,0,0,1,0,.44l.51.3a4.71,4.71,0,0,0,.06-.74A2.5,2.5,0,0,0,297.74,202.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.62,202.64a.45.45,0,0,0,0,.85,1.65,1.65,0,0,0,1.47,0,.45.45,0,0,0,0-.85A1.59,1.59,0,0,0,288.62,202.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.33,199.89a1.94,1.94,0,0,0-2,.14,6.15,6.15,0,0,0-2.48,3.56,1.41,1.41,0,0,0,.54.07,5.5,5.5,0,0,1,2.21-3.16,1.85,1.85,0,0,1,.9-.27,1.07,1.07,0,0,1,.53.13,2,2,0,0,1,.74,1.82,3.11,3.11,0,0,1,0,.43l.52.3a6.11,6.11,0,0,0,0-.73A2.54,2.54,0,0,0,293.33,199.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.45,239.45a.27.27,0,0,1-.25-.15.28.28,0,0,1,.1-.4l24.3-14a.28.28,0,0,1,.4.1.29.29,0,0,1-.11.4l-24.29,14A.28.28,0,0,1,297.45,239.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.51,237.75a.3.3,0,0,1-.26-.15.29.29,0,0,1,.11-.4l24.29-14a.29.29,0,0,1,.4.1.29.29,0,0,1-.1.41l-24.3,14A.23.23,0,0,1,294.51,237.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.57,236.05a.3.3,0,0,1-.26-.14.31.31,0,0,1,.11-.41l24.29-14a.29.29,0,0,1,.4.11.29.29,0,0,1-.11.4l-24.29,14A.23.23,0,0,1,291.57,236.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.62,234.35a.29.29,0,0,1-.25-.14.29.29,0,0,1,.11-.4l24.29-14a.29.29,0,1,1,.29.51l-24.29,14A.28.28,0,0,1,288.62,234.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.68,232.66a.29.29,0,0,1-.25-.15.29.29,0,0,1,.11-.4l24.29-14a.29.29,0,0,1,.29.51l-24.29,14A.42.42,0,0,1,285.68,232.66Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.74,231a.29.29,0,0,1-.25-.15.28.28,0,0,1,.1-.4l24.3-14a.29.29,0,0,1,.29.51l-24.29,14A.42.42,0,0,1,282.74,231Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.8,229.26a.3.3,0,0,1-.26-.15.29.29,0,0,1,.11-.4l24.29-14a.29.29,0,0,1,.4.11.28.28,0,0,1-.1.4l-24.3,14A.23.23,0,0,1,279.8,229.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.86,227.56a.29.29,0,0,1-.26-.15.29.29,0,0,1,.11-.4L301,213a.29.29,0,0,1,.29.51l-24.29,14A.23.23,0,0,1,276.86,227.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.91,225.86a.27.27,0,0,1-.25-.15.29.29,0,0,1,.11-.4l24.29-14a.28.28,0,0,1,.4.1.29.29,0,0,1-.11.4l-24.29,14A.28.28,0,0,1,273.91,225.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,224.16a.27.27,0,0,1-.25-.15.28.28,0,0,1,.1-.4l24.3-14a.29.29,0,0,1,.4.1.3.3,0,0,1-.11.41l-24.29,14A.28.28,0,0,1,271,224.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,222.46a.31.31,0,0,1-.26-.14.31.31,0,0,1,.11-.41l24.29-14a.31.31,0,0,1,.41.11.29.29,0,0,1-.11.4l-24.3,14A.23.23,0,0,1,268,222.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.09,220.76a.3.3,0,0,1-.26-.14.29.29,0,0,1,.11-.4l24.29-14a.29.29,0,0,1,.4.11.29.29,0,0,1-.1.4l-24.3,14A.32.32,0,0,1,265.09,220.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.14,219.07a.29.29,0,0,1-.14-.55l24.29-14a.29.29,0,0,1,.29.51l-24.29,14A.42.42,0,0,1,262.14,219.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.44,241.15a.3.3,0,0,1-.26-.15.29.29,0,0,1,.11-.4L326,225.74a.29.29,0,0,1,.29.51l-25.7,14.86A.23.23,0,0,1,300.44,241.15Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.28,222.89a2.13,2.13,0,0,0-1-.64l-.48-.25c-.23-.36-.52-.94-.13-1s.69.2.95.27.11-.16,0-.2c-.44-.17-1.26-.71-1.44,0a1.06,1.06,0,0,0,.1.68,1.37,1.37,0,0,0-.64-.12c-.2,0-.38,0-.45.26s0,.19,0,.29a.27.27,0,0,0,.21.21l-.23,0c-.31,0-1.14-.21-1.34.17-.08.15.1.37.08.43s-.61.23-.72.29,0,.2,0,.21a5,5,0,0,1-.88,0c-.49,0-1.69-.14-1.53.61,0,.08.08.07.09.2a1,1,0,0,0,0,.18s-.05,0-.11.1-.21,0-.27.12c-.23.29.12.39-.17.57s-1.25-.26-1.66,0,.11,1-.54,1c-.14,0-.06.21,0,.22.61,0,.54-.06.66-.56.19-.8,1.39-.25,2.06-.43a.12.12,0,0,0,.05-.18c-.17-.29,0-.44.3-.57a.11.11,0,0,0,.05-.17c-.07-.14-.33-.54-.17-.73a3.75,3.75,0,0,1,.71-.08c.53,0,1.05-.05,1.58,0a.11.11,0,0,0,.1-.15c-.08-.17.6-.27.75-.31a.11.11,0,0,0,.07-.14c-.33-.81.87-.51,1.36-.43.1,0,.17-.06.14-.15-.08-.28-.68-.55,0-.65a1.13,1.13,0,0,1,.54.13,3.9,3.9,0,0,0,1.24,1.28C313.17,223.6,313.64,223.44,313.28,222.89Zm-.22.14c.15.2-.32,0-.38,0a1.79,1.79,0,0,1-.62-.66l.37.19A1.46,1.46,0,0,1,313.06,223Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.13,228c-.09-.35-.1-.73.23-.77.15,0,0-.24-.07-.24-.44,0-.58.37-.52.83a2.41,2.41,0,0,0-.55-.19c-.29,0-.47-.06-.56.23s.08.29.07.44.21.14-.13.23a3.15,3.15,0,0,1-.41,0,.6.6,0,0,0-.59.18c-.21.18.32.27-.31.17a1.21,1.21,0,0,0-.5-.07c-.23,0-.36.12-.32.38,0,.11.27.27.27.34,0,.56-.61.09-.84,0a.11.11,0,0,0-.14.09c0,.28.18.37-.22.4-.05,0-.32-.15-.41-.16-.26,0-.5.34-.83.31a.1.1,0,0,0-.1.15c.09.26.23.41-.28.63l-.58-.08c-.15,0,0,.24.06.25s1,.34,1.25,0-.17-.5-.08-.64c-.06.09.44-.14.5-.16a1.48,1.48,0,0,1,.39-.11c.07,0,.13.12.21.12s.2,0,.29,0,.11-.16.14-.19-.11-.13.06-.19.24.09.36.12.48.2.64,0-.18-.45-.14-.63c.08-.39.65-.09.91-.27a.1.1,0,0,0,0-.12c-.16-.55.84-.12,1.16-.18.05,0,.11,0,.1-.11a3.5,3.5,0,0,0-.12-.35c.08-.33.53-.29.74-.24.2.67.73,1.35,1.31,1.17a.13.13,0,0,0,.08-.1C302.19,228.77,301.67,228.32,301.13,228Zm.21.55-.08-.15a1.28,1.28,0,0,1,.41.4C301.78,229.13,301.39,228.65,301.34,228.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,231.59a2.18,2.18,0,0,0-1-.64,5.36,5.36,0,0,1-.48-.24c-.23-.36-.53-1-.13-1a3,3,0,0,1,.94.28c.15,0,.11-.17,0-.21-.43-.17-1.26-.7-1.44,0a1.21,1.21,0,0,0,.1.68,1.44,1.44,0,0,0-.63-.12c-.21,0-.38,0-.45.27s0,.18,0,.28.17.2.21.21h-.23c-.31,0-1.15-.22-1.34.16-.08.16.1.38.08.44s-.61.22-.72.29,0,.19,0,.21a6.42,6.42,0,0,1-.88,0c-.49,0-1.69-.14-1.54.61,0,.08.09.07.1.2a.7.7,0,0,0,0,.19s0,0-.12.1-.21,0-.27.11c-.23.29.13.39-.16.57s-1.25-.26-1.66,0,.11,1-.54,1c-.14,0-.06.21.05.22.6.06.54-.06.65-.55.19-.81,1.4-.25,2.07-.44a.12.12,0,0,0,.05-.18c-.18-.28,0-.44.3-.56a.12.12,0,0,0,.05-.18c-.08-.13-.33-.53-.18-.72a3.93,3.93,0,0,1,.72-.09c.53,0,1.05-.05,1.57,0a.11.11,0,0,0,.1-.15c-.07-.17.61-.28.76-.31a.11.11,0,0,0,.06-.15c-.32-.8.88-.51,1.37-.43a.11.11,0,0,0,.14-.15c-.08-.27-.68-.54,0-.64a1.17,1.17,0,0,1,.55.13,3.91,3.91,0,0,0,1.24,1.28C309.84,232.3,310.32,232.14,310,231.59Zm-.22.15c.15.2-.32,0-.38,0a1.82,1.82,0,0,1-.62-.67,3.62,3.62,0,0,0,.37.2A1.43,1.43,0,0,1,309.74,231.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.43,225.42c-.09-.35-.1-.74.22-.78.16,0,.05-.23-.07-.24-.44,0-.58.37-.52.83a2.58,2.58,0,0,0-.55-.19c-.28,0-.47-.06-.56.23s.08.29.07.45.22.13-.13.22a1.39,1.39,0,0,1-.4,0,.63.63,0,0,0-.59.18c-.22.19.32.27-.32.17a1.41,1.41,0,0,0-.5-.07c-.23.06-.35.12-.31.38s.26.27.26.34c0,.56-.6.09-.83,0a.09.09,0,0,0-.14.08c0,.28.18.38-.22.4,0,0-.33-.15-.42-.15-.25,0-.49.33-.83.31-.09,0-.12.07-.09.15.09.25.23.4-.28.62l-.59-.07c-.14,0-.05.23.06.24s1,.35,1.25,0-.16-.5-.08-.65c-.06.1.45-.14.5-.16a1.67,1.67,0,0,1,.4-.1c.07,0,.12.11.2.11s.2.05.29,0,.11-.16.15-.18-.12-.13.06-.19.23.08.35.12.48.2.64,0-.17-.44-.14-.62c.08-.4.65-.1.91-.27a.12.12,0,0,0,0-.13c-.16-.55.84-.12,1.15-.17.06,0,.12-.05.11-.12s-.13-.34-.13-.34c.08-.33.54-.3.75-.24.2.67.73,1.34,1.31,1.16a.1.1,0,0,0,.07-.1C318.48,226.19,318,225.73,317.43,225.42Zm.2.55-.07-.16a1.33,1.33,0,0,1,.4.4C318.08,226.54,317.69,226.06,317.63,226Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.34,213a2.16,2.16,0,0,0-1-.64l-.48-.24c-.22-.36-.52-1-.12-1,.23,0,.69.2.94.27s.11-.16,0-.2c-.43-.17-1.26-.71-1.44,0a1.14,1.14,0,0,0,.1.68,1.35,1.35,0,0,0-.64-.12c-.2,0-.37,0-.45.26s0,.19,0,.29a.25.25,0,0,0,.21.21l-.24,0c-.3,0-1.14-.21-1.33.17-.08.15.1.37.07.43s-.61.23-.71.3,0,.19,0,.2a5.16,5.16,0,0,1-.89,0c-.48,0-1.69-.14-1.53.61,0,.08.08.07.1.2s0,.16,0,.18-.06,0-.12.1-.21,0-.27.12c-.23.29.12.39-.16.57s-1.25-.26-1.67,0,.11,1-.53,1c-.15,0-.06.21,0,.22.6.05.54-.06.65-.55.19-.81,1.39-.26,2.07-.44.08,0,.08-.12.05-.18-.18-.29,0-.44.29-.57.08,0,.09-.1.05-.17s-.32-.54-.17-.73a5.11,5.11,0,0,1,.72-.08c.52,0,1.05,0,1.57,0a.11.11,0,0,0,.1-.15c-.07-.16.61-.27.76-.31s.08-.09.06-.14c-.32-.81.87-.51,1.37-.43a.12.12,0,0,0,.14-.15c-.08-.27-.68-.55,0-.65a1.17,1.17,0,0,1,.55.13,3.63,3.63,0,0,0,1.24,1.28C295.22,213.68,295.7,213.52,295.34,213Zm-.22.14c.14.2-.32,0-.38,0a1.64,1.64,0,0,1-.62-.66l.37.2A1.47,1.47,0,0,1,295.12,213.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.19,218.08c-.09-.35-.1-.73.22-.77.16,0,0-.24-.07-.24-.44,0-.58.37-.52.83a2.72,2.72,0,0,0-.54-.19c-.29-.05-.48-.06-.57.23s.08.29.07.44.22.14-.13.23a2.85,2.85,0,0,1-.4,0c-.35,0-.38,0-.59.18s.32.27-.32.17a1.19,1.19,0,0,0-.49-.07c-.24.05-.36.12-.32.38s.27.27.26.34c0,.56-.6.09-.83,0a.11.11,0,0,0-.14.09c0,.28.18.37-.22.4-.05,0-.33-.15-.42-.15-.25,0-.49.33-.83.3a.1.1,0,0,0-.09.15c.09.26.23.41-.28.63l-.59-.08c-.14,0-.05.24.06.25s1,.35,1.25,0-.16-.5-.08-.64c-.05.09.45-.14.5-.16a1.68,1.68,0,0,1,.4-.11c.07,0,.13.12.2.12s.2,0,.29,0,.11-.16.15-.19-.12-.13.06-.19.24.09.35.13.48.2.64,0-.17-.45-.14-.62c.08-.4.65-.1.91-.28a.11.11,0,0,0,0-.12c-.16-.55.84-.12,1.15-.18.06,0,.12,0,.11-.11s-.13-.34-.13-.35c.08-.33.54-.29.75-.23.2.66.73,1.34,1.31,1.16a.11.11,0,0,0,.07-.1C284.24,218.85,283.72,218.4,283.19,218.08Zm.2.56-.07-.16a1.33,1.33,0,0,1,.4.4C283.84,219.21,283.45,218.73,283.39,218.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,221.67a2.11,2.11,0,0,0-1-.63l-.48-.25c-.22-.36-.52-.94-.13-1a3,3,0,0,1,.95.28c.14,0,.11-.17,0-.21-.43-.17-1.26-.7-1.44,0a1.13,1.13,0,0,0,.1.68,1.51,1.51,0,0,0-.64-.12c-.2,0-.38,0-.45.27s0,.19,0,.28a.24.24,0,0,0,.2.21h-.23c-.3,0-1.14-.22-1.34.16-.08.16.11.38.08.44s-.61.23-.71.29,0,.19,0,.21a8.47,8.47,0,0,1-.89,0c-.49,0-1.69-.15-1.53.6,0,.09.08.07.1.2a.9.9,0,0,0,0,.19s-.05,0-.11.1-.21,0-.27.11c-.23.29.12.39-.17.57s-1.25-.26-1.66,0,.11,1-.53,1c-.15,0-.06.22,0,.23.61.05.54-.07.66-.56.19-.81,1.39-.25,2.07-.44.08,0,.08-.12.05-.17-.18-.29,0-.45.29-.57a.12.12,0,0,0,.05-.18c-.07-.13-.33-.53-.17-.72a3.86,3.86,0,0,1,.72-.08,13.67,13.67,0,0,1,1.57,0,.11.11,0,0,0,.1-.15c-.08-.17.6-.28.75-.31a.11.11,0,0,0,.07-.14c-.33-.81.87-.51,1.37-.44a.11.11,0,0,0,.13-.15c-.07-.27-.67-.54,0-.64a1.13,1.13,0,0,1,.54.13,3.83,3.83,0,0,0,1.25,1.28C291.9,222.38,292.38,222.22,292,221.67Zm-.22.15c.15.2-.32,0-.37,0a1.81,1.81,0,0,1-.63-.66l.37.19A1.46,1.46,0,0,1,291.79,221.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.48,215.5c-.09-.35-.1-.74.23-.78.15,0,0-.23-.08-.24-.43,0-.57.37-.52.83a2.13,2.13,0,0,0-.54-.18c-.29-.06-.47-.07-.57.22s.09.29.08.45.21.13-.13.22a1.5,1.5,0,0,1-.41,0,.62.62,0,0,0-.59.19c-.21.18.32.26-.31.16a1.68,1.68,0,0,0-.5-.07c-.23.06-.36.12-.32.38s.27.27.27.35c0,.56-.61.08-.84,0a.1.1,0,0,0-.14.08c0,.28.18.38-.22.4-.05,0-.32-.15-.41-.15-.26,0-.5.34-.83.31-.09,0-.13.07-.1.15.09.25.23.4-.28.62,0,0-.59-.07-.58-.07-.15,0-.05.23.06.24s1,.35,1.25,0-.17-.5-.08-.65c-.06.1.44-.14.5-.16a1.48,1.48,0,0,1,.39-.1c.07,0,.13.11.2.11s.21.05.3,0,.11-.17.14-.19-.11-.13.06-.19.24.08.36.12.48.2.64,0-.18-.45-.14-.63c.08-.4.65-.1.91-.27a.11.11,0,0,0,0-.13c-.16-.55.84-.12,1.16-.17a.11.11,0,0,0,.1-.12,2.58,2.58,0,0,0-.12-.34c.08-.33.53-.3.74-.24.2.67.73,1.34,1.31,1.16a.09.09,0,0,0,.07-.1C300.54,216.27,300,215.81,299.48,215.5Zm.21.55a1.16,1.16,0,0,1-.08-.16,1.28,1.28,0,0,1,.41.4C300.13,216.63,299.74,216.14,299.69,216.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.86,227.66a2.16,2.16,0,0,0-1-.63l-.48-.25c-.23-.36-.53-.94-.13-1a3,3,0,0,1,.94.28c.15,0,.11-.17,0-.21-.43-.17-1.26-.7-1.44,0a1.21,1.21,0,0,0,.1.68,1.44,1.44,0,0,0-.63-.12c-.21,0-.38,0-.45.27s0,.19,0,.28a.26.26,0,0,0,.21.21h-.23c-.31,0-1.15-.22-1.34.16-.08.16.1.38.08.44s-.61.23-.72.29,0,.19,0,.21a8.32,8.32,0,0,1-.88,0c-.49,0-1.69-.15-1.54.6,0,.09.09.07.1.2a.7.7,0,0,0,0,.19s-.05,0-.12.1-.21,0-.27.11c-.23.29.13.39-.16.57s-1.25-.26-1.66,0,.11,1-.54,1c-.14,0-.06.22.05.23.6,0,.54-.07.65-.56.19-.81,1.4-.25,2.07-.44a.11.11,0,0,0,.05-.17c-.18-.29,0-.45.3-.57a.12.12,0,0,0,.05-.18c-.08-.13-.33-.53-.17-.72a3.75,3.75,0,0,1,.71-.08,13.76,13.76,0,0,1,1.57,0,.11.11,0,0,0,.1-.15c-.07-.17.61-.28.76-.31s.08-.09.06-.14c-.32-.81.88-.51,1.37-.44a.11.11,0,0,0,.14-.15c-.08-.27-.68-.54,0-.64a1.17,1.17,0,0,1,.55.13,3.81,3.81,0,0,0,1.24,1.28C293.74,228.37,294.22,228.21,293.86,227.66Zm-.22.15c.15.2-.32,0-.38,0a1.79,1.79,0,0,1-.62-.66,3.3,3.3,0,0,0,.37.19A1.52,1.52,0,0,1,293.64,227.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.77,222c-.09-.35-.1-.74.23-.78.16,0,0-.24-.07-.24-.44,0-.58.37-.52.83a2.58,2.58,0,0,0-.55-.19c-.28,0-.47-.06-.56.23s.08.29.07.44.21.14-.13.23a2.85,2.85,0,0,1-.4,0,.61.61,0,0,0-.59.18c-.22.19.32.27-.32.17a1.21,1.21,0,0,0-.5-.07c-.23,0-.35.12-.32.38s.27.27.27.34c0,.56-.61.09-.83,0a.1.1,0,0,0-.15.08c0,.28.19.38-.21.4-.05,0-.33-.15-.42-.15-.26,0-.49.33-.83.31-.09,0-.12.07-.1.15.1.25.23.4-.27.62l-.6-.08c-.13,0,0,.24.07.25s1,.35,1.25,0-.17-.49-.08-.64c-.06.1.45-.14.5-.16a1.6,1.6,0,0,1,.39-.11c.07,0,.13.12.21.12s.2.05.29,0,.11-.16.14-.18-.11-.14.07-.2.23.09.35.13.48.2.64,0-.18-.44-.14-.62c.08-.4.65-.1.91-.28a.1.1,0,0,0,0-.12c-.16-.55.83-.12,1.15-.18.05,0,.11,0,.11-.11s-.13-.34-.13-.35c.08-.33.53-.29.74-.23.21.67.74,1.34,1.32,1.16a.1.1,0,0,0,.07-.1C300.83,222.81,300.31,222.35,299.77,222Zm.21.55a.84.84,0,0,1-.07-.16,1.33,1.33,0,0,1,.4.4C300.42,223.16,300,222.68,300,222.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.55,217.48a.33.33,0,0,0,0-.14c-.09-.34-.49-.08-.56.13s.09.29.08.44.21.14-.13.23a3.15,3.15,0,0,1-.41,0,.59.59,0,0,0-.59.18c-.21.18.32.27-.31.17a1.21,1.21,0,0,0-.5-.07c-.23.05-.36.12-.32.38s.27.27.27.34c0,.56-.61.09-.84,0a.11.11,0,0,0-.14.09c0,.28.18.37-.22.4-.05,0-.32-.15-.41-.16-.26,0-.5.34-.83.31a.1.1,0,0,0-.1.15c.09.26.23.41-.28.63l-.59-.08c-.14,0,0,.24.07.25s1,.35,1.25,0-.17-.5-.09-.64c-.05.09.45-.14.51-.16a1.48,1.48,0,0,1,.39-.11c.07,0,.13.12.2.12s.21,0,.3,0,.11-.16.14-.19-.11-.13.06-.19.24.09.36.12.48.2.64,0-.18-.45-.14-.63c.08-.39.65-.09.91-.27a.1.1,0,0,0,0-.12c-.16-.55.84-.12,1.16-.18.05,0,.11-.05.1-.11a1.7,1.7,0,0,1,0-.71S306.54,217.53,306.55,217.48Z",
    style: {
      fill: "#455a64"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--light-bulb--inject-97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Idea--inject-97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Light--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.14,93.34a4,4,0,1,1-1.8-5.33A4,4,0,0,1,221.14,93.34Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.18,89.69c-1.68-2.53-.59-4.74,2.45-4.93A10.53,10.53,0,0,1,224.18,89c1.69,2.54.59,4.75-2.44,4.94A10.52,10.52,0,0,1,213.18,89.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.69,88.34c-1.74-2.61-.61-4.89,2.52-5.09A10.86,10.86,0,0,1,225,87.61c1.74,2.61.62,4.89-2.51,5.09A10.88,10.88,0,0,1,213.69,88.34Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.21,87c-1.79-2.69-.63-5,2.59-5.25a11.19,11.19,0,0,1,9.09,4.49c1.79,2.69.63,5-2.59,5.25A11.19,11.19,0,0,1,214.21,87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.75,85.51c-1.85-2.77-.65-5.19,2.67-5.41a11.58,11.58,0,0,1,9.37,4.63c1.85,2.77.65,5.2-2.68,5.41A11.53,11.53,0,0,1,214.75,85.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.36,84c-1.88-2.83-.66-5.3,2.73-5.52a11.79,11.79,0,0,1,9.56,4.72c1.88,2.83.66,5.3-2.73,5.52A11.79,11.79,0,0,1,215.36,84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.68,44.84a19,19,0,0,0-25.39,8.6c-6.67,13.49,3.35,21.23.66,26.66a3.26,3.26,0,0,0,.54,3.25,10.2,10.2,0,0,0,8.29,4.09,3.23,3.23,0,0,0,2.9-1.54h0c2.68-5.44,14.92-2.18,21.59-15.66A19,19,0,0,0,240.68,44.84Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.68,44.84a19,19,0,0,0-25.39,8.6c-6.67,13.49,3.35,21.23.66,26.66a3.26,3.26,0,0,0,.54,3.25,10.2,10.2,0,0,0,8.29,4.09,3.23,3.23,0,0,0,2.9-1.54h0c2.68-5.44,14.92-2.18,21.59-15.66A19,19,0,0,0,240.68,44.84Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M217.88,83.12c-1.23-1.85-.44-3.46,1.78-3.6a7.7,7.7,0,0,1,6.23,3.08c1.23,1.85.44,3.46-1.78,3.6A7.7,7.7,0,0,1,217.88,83.12Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.36,83.56a.65.65,0,0,1-.3-.85,46,46,0,0,1,6-9.12,23,23,0,0,1,2.18-2.28,9.05,9.05,0,0,1-1.11-1.45,11.2,11.2,0,0,1-1.32-3,11.22,11.22,0,0,1-3.19.78,8.56,8.56,0,0,1-1.83,0,23.46,23.46,0,0,1-.49,3.12A45.54,45.54,0,0,1,220.68,81a.64.64,0,0,1-1.14-.6,45.74,45.74,0,0,0,3.5-10,21.67,21.67,0,0,0,.47-3.11,4,4,0,0,1-2.75-2.54,2.05,2.05,0,0,1,.93-2.5,1.71,1.71,0,0,1,1.89.12c.82.63,1.24,2,1.25,3.9a7,7,0,0,0,1.66,0,10,10,0,0,0,3.06-.79,4.81,4.81,0,0,1,.76-3.65,1.81,1.81,0,0,1,3.1,1.53A4.71,4.71,0,0,1,231,66.26a9.68,9.68,0,0,0,1.24,2.92,7.09,7.09,0,0,0,1,1.3c1.51-1.15,2.86-1.64,3.86-1.37a1.71,1.71,0,0,1,1.24,1.43,2.07,2.07,0,0,1-1.42,2.26,4,4,0,0,1-3.68-.65A21.07,21.07,0,0,0,231,74.42a45.12,45.12,0,0,0-5.81,8.83.64.64,0,0,1-.86.31ZM222.72,63.4a.46.46,0,0,0-.44.05c-.47.25-.34.83-.29,1A2.55,2.55,0,0,0,223.53,66a3.67,3.67,0,0,0-.73-2.52Zm11.58,7.9a2.57,2.57,0,0,0,2.15.29c.17-.06.7-.31.61-.83-.05-.3-.18-.38-.31-.41C236.33,70.23,235.47,70.47,234.3,71.3Zm-2.44-8.62a.42.42,0,0,0-.59.09,3.08,3.08,0,0,0-.5,2.11,3.14,3.14,0,0,0,1.38-1.67A.43.43,0,0,0,231.86,62.68Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M244,38.42a1.31,1.31,0,0,1-.32-.1,1.25,1.25,0,0,1-.57-1.66l2.83-5.8a1.23,1.23,0,1,1,2.22,1.08l-2.82,5.8A1.23,1.23,0,0,1,244,38.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,35.72a1.25,1.25,0,0,1-1-1.13l-.46-6.44A1.24,1.24,0,1,1,231,28l.46,6.44a1.23,1.23,0,0,1-1.14,1.32A1.13,1.13,0,0,1,230,35.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.5,40.37a1.24,1.24,0,0,1-.79-.52l-3.62-5.35a1.24,1.24,0,1,1,2-1.39l3.62,5.35a1.24,1.24,0,0,1-.34,1.72A1.22,1.22,0,0,1,216.5,40.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.16,51.15a1.15,1.15,0,0,1-.31-.11L201,48.22A1.24,1.24,0,0,1,202.12,46l5.81,2.82a1.24,1.24,0,0,1-.77,2.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,91.36a1.24,1.24,0,0,1-.8-.52l-3.62-5.35a1.24,1.24,0,0,1,2.05-1.39l3.62,5.35a1.25,1.25,0,0,1-.33,1.72A1.23,1.23,0,0,1,251,91.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.51,78.06a1.31,1.31,0,0,1-.32-.1l-5.8-2.82a1.24,1.24,0,0,1,1.08-2.23l5.81,2.82a1.24,1.24,0,0,1-.77,2.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.41,61.24a1.24,1.24,0,0,1,.14-2.45l6.44-.46a1.24,1.24,0,1,1,.17,2.47l-6.44.46A1.06,1.06,0,0,1,259.41,61.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.75,47.76a1.29,1.29,0,0,1-.8-.52,1.25,1.25,0,0,1,.33-1.72l5.35-3.61A1.24,1.24,0,0,1,261,44l-5.35,3.61A1.22,1.22,0,0,1,254.75,47.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pi--inject-97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pi--inject-97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.33,318.64l-12.17,7q-.9,14.63-1.74,24.15t-1.63,16.46q-.8,7-1.64,12.78a31.78,31.78,0,0,1-2,7.66,16.18,16.18,0,0,1-3.9,5.52,4.25,4.25,0,0,1-4.19,1.29,3.45,3.45,0,0,1-2.5-2.91,10.84,10.84,0,0,1-.16-3.11,15.67,15.67,0,0,1,.58-2.75,25.34,25.34,0,0,1,.95-2.59q.52-1.21,1.11-2.46c.1-.25.71-1.56,1.82-3.93a55,55,0,0,0,2.5-6.19,23.46,23.46,0,0,0,1.05-5.35l3.16-34.77-5.11,2.95a14.62,14.62,0,0,0-4.11,3.74,22.86,22.86,0,0,0-3,4.93l-2.27,5.81L406.24,348c.49-2.11,1.11-4.65,1.84-7.63a65,65,0,0,1,3.06-9.18,36.59,36.59,0,0,1,4.11-7.6,18.67,18.67,0,0,1,6-5.68l40.25-23.24V307l-13.59,7.85q-1.32,17.55-1.32,34.55a18.3,18.3,0,0,0,.79,5.58,6.66,6.66,0,0,0,1.95,3.37,4,4,0,0,0,3.61.27q2.13-.71,4.34-4.3a15.64,15.64,0,0,0,1.77-3.9,20.69,20.69,0,0,0,.71-3.5c.11-1,.21-2.09.32-3.13l2.26-1.31A53.56,53.56,0,0,1,458,363a32.67,32.67,0,0,1-3.42,6.09,18.77,18.77,0,0,1-4.43,4.42c-1.69,1.18-3.23,1.55-4.64,1.09q-3.46-1.36-5.26-7.56a45.08,45.08,0,0,1-1.14-10.48q-.13-6.85.35-13.72Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.33,318.64l-12.17,7q-.9,14.63-1.74,24.15t-1.63,16.46q-.8,7-1.64,12.78a31.78,31.78,0,0,1-2,7.66,16.18,16.18,0,0,1-3.9,5.52,4.25,4.25,0,0,1-4.19,1.29,3.45,3.45,0,0,1-2.5-2.91,10.84,10.84,0,0,1-.16-3.11,15.67,15.67,0,0,1,.58-2.75,25.34,25.34,0,0,1,.95-2.59q.52-1.21,1.11-2.46c.1-.25.71-1.56,1.82-3.93a55,55,0,0,0,2.5-6.19,23.46,23.46,0,0,0,1.05-5.35l3.16-34.77-5.11,2.95a14.62,14.62,0,0,0-4.11,3.74,22.86,22.86,0,0,0-3,4.93l-2.27,5.81L406.24,348c.49-2.11,1.11-4.65,1.84-7.63a65,65,0,0,1,3.06-9.18,36.59,36.59,0,0,1,4.11-7.6,18.67,18.67,0,0,1,6-5.68l40.25-23.24V307l-13.59,7.85q-1.32,17.55-1.32,34.55a18.3,18.3,0,0,0,.79,5.58,6.66,6.66,0,0,0,1.95,3.37,4,4,0,0,0,3.61.27q2.13-.71,4.34-4.3a15.64,15.64,0,0,0,1.77-3.9,20.69,20.69,0,0,0,.71-3.5c.11-1,.21-2.09.32-3.13l2.26-1.31A53.56,53.56,0,0,1,458,363a32.67,32.67,0,0,1-3.42,6.09,18.77,18.77,0,0,1-4.43,4.42c-1.69,1.18-3.23,1.55-4.64,1.09q-3.46-1.36-5.26-7.56a45.08,45.08,0,0,1-1.14-10.48q-.13-6.85.35-13.72Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M454.37,290.5l-40.25,23.24a19,19,0,0,0-6,5.68A36.91,36.91,0,0,0,404,327a64.9,64.9,0,0,0-3.05,9.18c-.74,3-1.35,5.52-1.85,7.63l7.14,4.12c.49-2.11,1.11-4.65,1.84-7.63a65,65,0,0,1,3.06-9.18,35.46,35.46,0,0,1,2.23-4.61c.58-1,1.19-2,1.88-3a18.67,18.67,0,0,1,6-5.68l40.25-23.24Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.37,290.5l-40.25,23.24a19,19,0,0,0-6,5.68A36.91,36.91,0,0,0,404,327a64.9,64.9,0,0,0-3.05,9.18c-.74,3-1.35,5.52-1.85,7.63l7.14,4.12c.49-2.11,1.11-4.65,1.84-7.63a65,65,0,0,1,3.06-9.18,35.46,35.46,0,0,1,2.23-4.61c.58-1,1.19-2,1.88-3a18.67,18.67,0,0,1,6-5.68l40.25-23.24Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.14,331.15a35.46,35.46,0,0,1,2.23-4.61c.58-1,1.19-2,1.88-3a18.67,18.67,0,0,1,6-5.68l40.25-23.24-7.14-4.13,4.62,4.13L421.18,316.2c-4.44,2.53-10.91,7.58-14.94,31.76.49-2.11,1.11-4.65,1.84-7.63A65,65,0,0,1,411.14,331.15Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "455.21 338.35 462.35 342.47 460.09 343.78 452.95 339.66 455.21 338.35",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "455.21 338.35 462.35 342.47 460.09 343.78 452.95 339.66 455.21 338.35",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M460.09,343.78l-5-2.87L453,339.66c-.11,1-.21,2.08-.32,3.13a19.74,19.74,0,0,1-.71,3.5,16,16,0,0,1-1.76,3.9,12.51,12.51,0,0,1-3.08,3.62c.09.4.19.79.31,1.16a6.66,6.66,0,0,0,1.95,3.37,3.24,3.24,0,0,0,1.54.54,4.85,4.85,0,0,0,2.07-.27q2.13-.71,4.34-4.3a15.64,15.64,0,0,0,1.77-3.9,20.69,20.69,0,0,0,.71-3.5c.11-1,.21-2.09.32-3.13",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M460.09,343.78l-5-2.87L453,339.66c-.11,1-.21,2.08-.32,3.13a19.74,19.74,0,0,1-.71,3.5,16,16,0,0,1-1.76,3.9,12.51,12.51,0,0,1-3.08,3.62c.09.4.19.79.31,1.16a6.66,6.66,0,0,0,1.95,3.37,3.24,3.24,0,0,0,1.54.54,4.85,4.85,0,0,0,2.07-.27q2.13-.71,4.34-4.3a15.64,15.64,0,0,0,1.77-3.9,20.69,20.69,0,0,0,.71-3.5c.11-1,.21-2.09.32-3.13"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M441.51,370.23A20,20,0,0,1,440.3,367a26.17,26.17,0,0,1-.66-3.39,64.25,64.25,0,0,1-.47-7.09q-.14-6.84.34-13.72c.59-7.77,1.36-17.81,1.84-24.18l-7.79,4.5-1.19,15.55q-.48,6.88-.34,13.72a45.21,45.21,0,0,0,1.13,10.49q1.62,5.6,4.62,7.24v0l6.94,4A8.84,8.84,0,0,1,441.51,370.23Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.51,370.23A20,20,0,0,1,440.3,367a26.17,26.17,0,0,1-.66-3.39,64.25,64.25,0,0,1-.47-7.09q-.14-6.84.34-13.72c.59-7.77,1.36-17.81,1.84-24.18l-7.79,4.5-1.19,15.55q-.48,6.88-.34,13.72a45.21,45.21,0,0,0,1.13,10.49q1.62,5.6,4.62,7.24v0l6.94,4A8.84,8.84,0,0,1,441.51,370.23Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.56,323.14l-.45,5.85h0l7.15,2.89.09-.14c.37-4.82.73-9.54,1-13.1Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.47,330.1l-4,2.32,0,0h0a12.18,12.18,0,0,0-2.16,1.62l-.69.69-2.31,25.37a23.46,23.46,0,0,1-1,5.35,55.17,55.17,0,0,1-2.51,6.18c-1.1,2.38-1.71,3.69-1.81,3.93-.39.84-.76,1.66-1.11,2.47a25.15,25.15,0,0,0-1,2.58,16,16,0,0,0-.58,2.76,10.86,10.86,0,0,0,.16,3.11,3.51,3.51,0,0,0,1.64,2.53h0l7.1,4.12h0a3.48,3.48,0,0,1-1.61-2.52,10.93,10.93,0,0,1-.19-2.78c0-.11,0-.22,0-.33a15.08,15.08,0,0,1,.58-2.76,25.15,25.15,0,0,1,.95-2.58c.29-.68.6-1.36.92-2.05,0-.15.12-.28.18-.42l1.82-3.93c.56-1.2,1-2.31,1.46-3.35,0-.06.05-.13.08-.19h0l.36-.94c.08-.2.15-.41.23-.61.13-.37.26-.74.37-1.09a24,24,0,0,0,1.06-5.35l3.16-34.77Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.47,330.1l-4,2.32,0,0h0a12.18,12.18,0,0,0-2.16,1.62l-.69.69-2.31,25.37a23.46,23.46,0,0,1-1,5.35,55.17,55.17,0,0,1-2.51,6.18c-1.1,2.38-1.71,3.69-1.81,3.93-.39.84-.76,1.66-1.11,2.47a25.15,25.15,0,0,0-1,2.58,16,16,0,0,0-.58,2.76,10.86,10.86,0,0,0,.16,3.11,3.51,3.51,0,0,0,1.64,2.53h0l7.1,4.12h0a3.48,3.48,0,0,1-1.61-2.52,10.93,10.93,0,0,1-.19-2.78c0-.11,0-.22,0-.33a15.08,15.08,0,0,1,.58-2.76,25.15,25.15,0,0,1,.95-2.58c.29-.68.6-1.36.92-2.05,0-.15.12-.28.18-.42l1.82-3.93c.56-1.2,1-2.31,1.46-3.35,0-.06.05-.13.08-.19h0l.36-.94c.08-.2.15-.41.23-.61.13-.37.26-.74.37-1.09a24,24,0,0,0,1.06-5.35l3.16-34.77Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M421.61,340l1-10.49-1.1.63-4,2.32,0,0h0a12.18,12.18,0,0,0-2.16,1.62l-.69.69-.24,2.62Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutory2);
export default __webpack_public_path__ + "static/media/tutory2.5284a03d6821b0a200e4899e8e3bea14.svg";
export { ForwardRef as ReactComponent };